export default {
  login: {
    'Welcome_to_TC_system': "Bienvenido al sistema TC",
    "Login_account": "Entrar a cuenta",
    "Please_enter_your_login_account": "Por favor ingrese una cuenta de login",
    "Login_password": "Login contraseña",
    "Please_enter_your_login_password": "Por favor ingrese su contraseña de acceso",
    "Remember_the_account_password": "Recuerda la contraseña por favor",
    "Enterprise_wechat_login": "Empresa wechat iniciar sesión",
    "logining": "Iniciar sesión en",
    "Login_success": "Inicio de sesión exitoso",
    "Login_failure": "Inicio de sesión fallado",
    "exit": "salida",
    "exiting": "Saliendo",
    "Exit_successfully": "Éxito de salida",
    "Exit_failure": "Fracaso de salida",
    "Welcome_to_login_TC_system": "Bienvenido a iniciar sesión en el sistema TC",
    "account": "acceso de cuenta",
    "Password": "contraseña",
    "Please_enter_login_account": "Por favor ingrese la cuenta de acceso",
    "Please_enter_login_password": "Por favor ingrese la contraseña",
    "Log_in_Wecom": "Acceso de Wecom",
    "Log_in": "Acceso",
    "It_is_on_the_access_road": "Está en camino de acceso",
    "Access_error": "error de acceso",
  },
  menu: {
    "WarehouseData": "Datos de almacén",
    "operate_time": "Tiempo de operación",
    "View_details": "Ver los detalles",
    "Warehousing_management": "Gestion de almacenes",
    "Out_warehouse_management": "Gestión de salida",
    "Order_management": "Gestión de pedidos",
    "Pallet_management": "Gestión de palets",
    "Abnormal_data": "Datos anormales",
    "Warehousing_anomaly": "Excepción de entrada",
    "Outgoing_exception": "Excepción de salida",
    "Operation_exception": "Anomalía operativa",
    "Vehicle_management": "Gestión de vehículos",
    "Order_list": "Catálogo de pedidos",
    "warehouse_data": "dato de bodega",
    "goods_age_statistics": "estadísticas de edad de los productos",
    "data_statistics": "estadísticas de datos",
    "classification_data": "dato de clasificación",
    "classification_details": "detalles de clasificación",
    "pela_details": "detalles de pelá",
    "cargo_entry_management": "administración de ingreso de carga",
    "cargo_entry_details": "detalles de ingreso de carga",
    "Shipment_details": "detalles de envío",
    "load_output_administration": "administración de salida de carga",
    "load_output_details": "detalles de salida de carga",
    "order_administration": "administración de pedidos",
    "order_details": "detalles de pedidos",
    "abnormal_load_input_situation": "situación anormal de ingreso de carga",
    "abnormal_situation_details": "detalles de situación anormal",
    "load_output_abnormal_situation": "situación anormal de salida de carga",
    "abnormal_driving_situation": "situación anormal de manejo",
    "container_administration": "Administración de envase/palet",
    "container_details": "Detalles de envase/palet",
    "location_management": "gestión de ubicación",
    "classification_management": "gestión de clasificación",
    "platform_management": "Administración de envase/palet",
    "car_management": "Gestión de veículo",
    "Mercado_Libre_Reservation": "Reserva de Mercado Libre",
    "Reservation_status": "Proceso de reserva",
    "Check_the_shipment_number": "Imformación de código de envío",
    "Basic_setup": "Configuración básica",
    "Warehouse_details": "Detalles de almacén",
    "Enterprise_architecture_management": "Administración de arquitectura empresarial",
    "System_setting": "Configuración del sistema",
    "Department_setting": "Configuración del departamento",
    "Employee_account_management": "Gestión de cuentas de empleados",
    "Role_rights_management": "Administración de permisos de rol",
    "Role_setting": "Configuración de roles",
    "Authority_management": "Gestión de derechos",
    "Work_order_management": "Gestión de órdenes de trabajo",
    "Add_new_work_order": "Crear un nuevo órdenes de trabajo",
    "Work_order_details": "Detalles de órdenes de trabajo",
    "Customer_service_Settings": "Configuración del servicio de atención al cliente",
    "Work_order_type": "Tipo de órdenes de trabajo",
    "Problem_type": "Tipo de problema",
    "Drafts": "Borrador",
    "check": "Consultar",
    "add": "Crear",
    "intercept": "Intercepción de salida",
    "updateFiles": "Actualizar archivos adjuntos",
    "delete": "Eliminar",
    "cancel": "Cancelar la entrega",
    "edit": "Editar",
    "download": "Descargar",
    "storage_management": "Gestión de ubicación",
    "No_owner_claimed_the_goods": "Ningún propietario reclama la mercancía",
    "return_claim": "Devolución y reclamación",
    "loadingLot": "Lote de carga",
    "lotDetail": "Detalle del lote",
    "return_goods": "Devolución/EE.UU. México",
    "returnGoods": "Devolución/EE.UU. México",
    "warehouse": "Ingreso de carga",
    "outwarehouse": "Salida de carga",
    "refuseOutwarehouse": "Rechazo de devolución",
    "transfer": "Tranferir",
    "inventory": "Inventario",
    "pickGoods": "Seleccionar mercancía",
    "listGoods": "Manipulación de carga",
    "outerSheet": "Etiqueta de envío",
    "productSheet": "Etiqueta de productos",
    "findGoods": "Revisar mercancía",
    "claimGoods": "Reclamación de carga",
    "truckLoading": "Carga y embarque",
    "picsUpload": "Carga de imágenes",
    "changeLabel": "Cambio de etiqueta",
    "checkZone": "Revisar ubicación",
    "Update": "Actualizar",
    "pda": "pda",
    "areaScan": "Área de escaneo",
    "goods_ageing": "Antigüedad de la carga",
    "zoneInventory": "Inventario de ubicación",
    "workSheet": "Procesamiento de órdenes de trabajo",
    "storage_list": "Lista de almacenamiento",
    "storage_of_goods": "Almacenamiento de mercancías",
    "cargo_storage_details": "Detalles de almacenamiento de mercancías",
    "cargo_delivery_information": "Información de entrega de carga al almacén",
    "abnormal_shipments": "envíos de inventario anormales",
    "first_route_order": "Primer orden de ruta",
    "transfer_warehouse_order": "Pedido de transferencia de almacén",
    "order_detail": "Detalle del pedido",
    "transferWarehouseProcess": "Proceso de transferencia de almacén",
    "transferToWarehouse": "Transferencia a almacén",
    "warehouseOrder": "Pedido de almacén",
    "drop_shipping_outwarehouse": "Envío directo desde almacén",
    "drop_shipping_outwarehouse_detail": "Detalles de envío directo desde almacén",
    "picking_task": "Tarea de recogida",
    "picking_order": "Orden de selección",
    "picking_outwarehouse": "Selección de salida de almacén",
    "task_detail": "Detalles de tareas",
    "warehousing_manage": "Gestión del almacenamiento",
    "container_manage": "Gestión de Contenedores en Dropshipping",
    "location_manage": "Gestión de Ubicaciones de Almacén en Dropshipping",
    "distribution_manage": "Gestión de la distribución",
    "shelves_manage": "Gestión de estanterías",
    "pull_on_shelves_list": "Lista de subida de estantes",
    "pull_off_shelves_list": "Lista de bajada de estantes",
    "warehouse_manage": "Gestión del almacén",
    "goods_stock": "Depósito de mercancía",
    "sku_stock": "Inventario total de SKU",
    "sku_batch_stock": "Inventario por lotes de SKU",
    "sku_shelf_stock": "Inventario de estanterías de SKU",
    "inventory_adjustment": "Ajuste de inventario",
    "container_detail": "Detalle del envase",
    "product_information": "Información del producto",
    "order_manage": "Gestión de pedidos",
    "all_order": "Todos los pedidos",
    "shein_order": "Pedidos de SHEIN",
    "warehouse_detail": "Detalle del almacén",
    "subarea_detail": "Detalle de subárea",
    "location_detail": "Detalle de ubicación",
    "goods_stock_detail": "Detalle de la mercancía",
    "general_situation": "Situación general",
    "batchOutWarehouse": "Lote salir del almacén",
    "UpdateTheOutboundTime": "Actualizar la hora de salida",
    "DestroyGoods": "Se solicitar de destrucción de mercancía",
    "system_setting": "Configuración del sistema",
    "courier_freight_manage": "Gestión de tarifas transporte de mensajerías",
    "setupOutaccount": "Configuración de la cuenta de salida",
    "shipment": "Información del código de envío",
    "changeShipment": "Cambio de etiqueta del código de envío",
    "batchDistributionWorkSheet": "Orden de trabajo de distribución por lotes",
    "warehouse_order": "Orden de almacén",
    "new_order": "Crear un nuevo órden de pedido",
    "good_change_label": "Cambio de etiqueta de mercancía",
    "good_change_label_detail": "Detalles de cambio de etiqueta de mercancía",
    "account_information": "Información de la cuenta",
    "login": "Inicio de sesión",
    "logout": "Cierre de sesión",
    "userinfo": "Información del usuario",
    "operating_function": "Funciones de operación",
    "Home_Page_Functions": "Funciones de la Página Principal",
    "goods_sku_stock": "Inventario de SKU de mercancías",
    "goods_in_warehouse": "almacenamiento de mercancías",
    "out_of_stock_order_change_label": "Cambio de etiqueta en orden de salida de almacén",
    "out_of_stock_order_change_label_details": "Detalles del cambio de etiqueta en orden de salida de almacén",
    "rfid": "RFID",
    "search_goods_task": "Tarea de búsqueda de mercancías",
    "search_goods_task_details": "Detalles de la tarea de búsqueda de mercancías",
    "related_sub_order": "Subpedido relacionado",
    "inbound_inspection_task": "Tarea de inspección de entrada al almacén",
    "inbound_inspection_task_details": "Detalles de la tarea de inspección de entrada al almacén",
    "findGoodsOutwarehouse": "Inspeccionar mercancía al salir del almacén",
    "overseas_qr_code_statistics": "Overseas sweep estadísticas de códigos",
    "employee_name": "nombre del empleado",
    "Time_selection": "Selección de tiempo",
    "Scan_code_statistics": "Escaneo de estadísticas",
    "Statistics_of_scanning_and_entering_warehouse": "Estadísticas de entrada por escaneo de código",
    "Scan-to-issue_statistics": "Estadísticas de salida por escaneo de código",
    "Statistics_of_scanning_and_listing": "Estadísticas de escaneo y colocación en estantería",
    "Statistics_of_products_removed_from_shelves_after_scanning": "Estadísticas de retirada por escaneo de código",
    "Scan_and_count_statistics": "Cuenta y estadísticas por escaneo de código",
    "Scan_outer_box_label_statistics": "Estadísticas de etiquetas de cajas exteriores escaneadas",
    "Scan_product_labels_for_statistics": "Escaneo de etiquetas de productos para estadísticas",
    "warehouse_loading": "Carga en el almacén",
    "Details_of_warehouse_delivery": "Detalles de entrega al almacén",
    "Warehouse_delivery": "Almacén de entrega",
    "Number_of_items_scanned_and_released_from_storage": "Número de artículos escaneados y salidos del almacén",
    "Number_of_items_to_be_issued_from_storage": "Número de artículos que deben ser retirados del almacén",
    "Number_of_vehicles_that_should_be_loaded": "Número de unidades a cargar",
    "Number_of_vehicles_loaded": "Número de unidades ya cargadas",
    "Number_of_units_not_loaded": "Número no cargado",
    "Please_select_the_delivery_date_first": "Por favor, seleccione primero la fecha de envío al almacén",
    "Scanned_and_loaded": "Escaneado y cargado",
    "Scanned_and_loaded_onto_the_vehicle": "Se ha escaneado el Código para cargar el coche",
    "Loading_without_scanning_the_code": "Loading without scanning the code",
    "truckCarScan": "Escanear el código durante la carga",
    "outbound_order_extraction_label": "Etiqueta de extracción de orden de salida",
    "Tag_separation": "División de etiquetas",
    "abnormal_update_prompt": "Aviso de actualización anormal",
    "Are_you_sure_you_want_to_split_the_labels": "Está seguro de que desea dividir la etiqueta",
    "Are_you_sure_you_want_to_clear_all_uploaded_files": "¿Seguro que quieres vaciar todos los archivos subidos?",
    "Please_enter_the_file_name": "Por favor ingrese un nombre",
    "Please_upload_and_complete_the_segmentation_first": "Por favor, cargue primero y complete la división",
    "Please_select_the_warehouse_delivery_date": "Por favor seleccione la fecha de entrega",
    "Cleared": "Vacío",
    "No_files_available_for_upload": "No hay archivos para subir",
    "In_the_process_of_packaging_and_uploading": "En proceso de empaquetado y carga",
    "Split_successfully": "división exitosa",
    "ocr_extract_excel": "Extraer excel con OCR",
    "truck_loading_bonded_warehouse": "Carga en el almacén",
    "truck_loading_bonded_warehouse_details": "Detalles de carga en el almacén",
    "warehousing_summary": "Resumen de ingreso",
    "warehousing_summary_details": "Detalles de resumen de ingreso",
    "Amazon_appointment_delivery_registration": "Registro de entrega con cita de Amazon",
    "Amazon_delivery_shipping_information": "Información de envío de almacén de Amazon",
    "Top_function": "Función superior",
    "Large_screen_data_dashboard": "Panel de datos de pantalla grande",
    "show_board": "Función de panel de pantalla grande",
    "setUnknown": "Cambiar el inventario a desconocido",
  },
  selectPart: {
    "Operation_center": "Operación",
    "order_center": "Pedidos",
    "Enterprise_center": '',
    "Service_center": 'Gestión de órdenes de trabajo',
    "pda": "pda",
    "PDA_dropShipping": "Envío directo PDA",
    "Inventory_center": "inventario",
    "distribution_center": "Centro de distribución",
    "other_mode": "Otros módulos",
  },
  warehouseData: {
    "Goods_to_be_listed": "Productos para colocar en el estante",
    "Container_code_to_be_listed": "Código del contenedor a ser listado",
    "Current_pieces": "piezas ahora",
    "Current_pieces_of_order/ticket": "cantidad de pedidos actuales/boleto",
    "Total_weight": "peso total",
    "Total_weight/volume": "capacidad total/volumen",
    "Pending_arrival_orders_at_the_warehouse": "pedidos de llegada pendiente de almacén",
    "Orders_pending_handling": "pedidos pendiente de manejo",
    "abnormal_orders": "pedidos anormales",
    "orders_that_have_been_held_for_a_long_time": "pedidos que se han reservado por mucho tiempo",
    "Total_pieces": "piezas totales",
    "Total_volume": "volumen total",
    "Total_order/ticket": "pedidos totales/boleto",
    "Day": "día",
    "Month": "mes",
    "Year": "año",
    "cargo_intake_today/piece": "ingreso de carga hoy/pieza",
    "Morning": "mañana",
    "Afternoon": "tarde",
    "cargo_departure_today/piece": "salida de carga hoy/pieza",
    "Handling_today/piece": "manejo hoy/pieza",
    "Classification_of_warehouse_area": "áreas de almacén",
    "Import_data": "importar datos",
    "reservation_space_is_less_than": "espacio de reserva es menor que",
    "cargo_entry_worker": "trabajador de ingreso de carga",
    "Time_of_warehousing": "hora de ingreso de carga",
    "Warehouse": "bodega donde estás ahora ",
    "classification_area": "área de clasificación",
    "pallet_number": "número de tarima",
    "deposit_time": "tiempo de depósito",
    "secondary_shipment_number": "número de envío secundaria",
    "secondary_shipping/secondary_outer_carton_label": "envío secundaria/etiqueta de caja exterior secundaria",
    "Pieces": "piezas",
    "Weight": "peso",
    "Number_of_shipment": "número de envío",
    "Number_of_entering_warehouse": "número de ingreso de carga",
    "Number_of_products/tag": "envío/etiqueta de caja exterior de caja",
    "choose_classification_area": "elegir área de clasificación",
    "filter": "filtro",
    "Reset": "reinicio",
    "Client_name": "nombre de clientes",
    "Salesman": "vendedor",
    "deposit_time/day": "tiempo de depósito/día",
    "handling": "manejo",
    "Check": "revisar",
    "Please_enter_content": "Por favor ingrese contenido ",
    "No_region_storage_information_was_entered": "No se ha introducido información de área reservada",
    "Storage_space_less_than": "Espacio de reserva es menor que",
    "Search_results": "Resultado de busca",
    "Total": "Piezas totales",
    "Old_shipment_number": "Número de envío viejo ",
    "Old_sub-shipment_number/shipping_mark": "Antiguo número de subenvío/marca de envío",
    "change_order_number": "Corregir número de envío",
    "region_name": "Nombre de zona",
    "status": "Estado",
    "Update_time": "Tiempo actualizado",
    "volume": "Volumen",
    "Data_export": "Exportar datos",
    "Already_listed": "Ya en estante",
    "Taken_down": "Ha sido retirado",
    "De_listing": "Retirar del estante",
    "Total_number_of_locations": "Número total de ubicaciones",
    "The_number_of_used_storage_locations": "Número de ubicaciones de almacenamiento utilizadas",
    "Number_of_empty_storage_locations": "Número de ubicaciones de almacenamiento vacías",
  },
  warehousing: {
    "delivery_number": "número de envío",
    "cargo_entry_number": "número de ingreso de carga",
    "shipping/outer_box_label": "envío/etiqueta de caja exterior",
    "state": "estado",
    "Container_pick_up_date": "fecha de retirar contenedores",
    "cargo_entry_time": "hora de ingreso de carga",
    "import_data": "importar datos",
    "export_data": "exportar datos",
    "Container_number": "Número del contenedor",
    "SO_number": "SO Número",
    "filter": "filtro",
    "reboot": "reinicio",
    "pick_up_order_number/container_number": "número de recoger pedido/número de contenedor",
    "type_of_transport": "tipo de transporte",
    "related_shipping_quantity/pcs": "cantidad de envío relacionado/piezas",
    "total_pieces/piece": "piezas totales/pieza",
    "total_volume/cubic_meters": "volumen total/metros cúbicos",
    "total_weight/kg": "peso toal/kilogramo",
    "warehouse_receipt_amount/piece": "cantidad de ingreso de bodega/pieza",
    "review": "revisar",
    "secondary_shipment_number": "número de envío secundaria",
    "secondary_shipping/secondary_outer_carton_label": "envío secundaria/etiqueta de caja exterior secundaria",
    "product_parts/parts": "piezas de productos/piezas",
    "volume/cubic_meters": "volumen/metros cúbicos",
    "weight/kg": "peso/kilogramo",
    "have_been_entered": "se han ingresado",
    "total_pieces": "piezas totales",
    "total_weight": "peso total",
    "total_volume": "volumen total",
    "cargo_entry_parts": "piezas de ingreso de carga",
    "pieces_without_charge_entry": "piezas sin ingreso de carga",
    "driving": "manejo",
    "print_income_sheet": "imprimir hoja de ingreso",
    "export_income_sheet": "exportar hoja de ingreso",
    "warehousing": "Pendiente de ingreso",
    "Failed_to_get_warehousing_list": "Han fallado obtener lista de ingreso",
    "Transport_type": "Tipo de transportante",
    "Failed_to_get_warehousing_details": "Han fallado obtener detalles de ingreso",
    "Failed_to_get_waybill_details": "Han fallado obtener detalles de pedidos",
    "shipping": "envío",
    "secondary_shipping": "envío secundaria",
    "location_code/container_code": "código de ubicación/código de envase",
    "all": "Todo",
    "warehoused": "Se han salido",
    "exporting": "Está exportando",
    "Export_successfully": "Exportación exitosa",
    "printing": "Está imprimiendo",
    "Print_successfully": "Imprimir exitosamente",
    "Print_unsuccessfully": "Imprimir falsamente",
    "Company_logo": "Empresa logo",
    "Export_unsuccessfully": "Exportación falsa",
    "RFID_quantity": "Cantidad de RFID",
    "New_RFID_inbound_inspection_has_been_added": "Se ha añadido una nueva inspección de entrada de RFID",
    "The_new_RFID_inbound_detection_has_been_successfully_added": "Se ha añadido con éxito la nueva detección de entrada de RFID",
    "The_new_RFID_inbound_inspection_failed": "Falló la nueva inspección de entrada de RFID",
    "The_number_of_items_on_the_inventory_sheet_does_not_match_the_number_of_RFID_tags_Are_you_sure_you_want_to_proceed_with_creation": "El número de artículos en la hoja de inventario no coincide con el número de etiquetas RFID. ¿Está seguro de que desea proceder con la creación?",
    "The_number_of_leading_stars_is_odd": "El número de estrellas principales es impar",
    "The_number_of_stars_received": "Cantidad de estrellas recibidas",
  },
  outwarehouse: {
    "delivery_number": "número de envío",
    "load_output_number": "número de salida de carga",
    "shipping/outer_box_label": "envío/etiqueta de caja exterior",
    "state": "estado",
    "creation_date": "fecha de creación",
    "cargo_departure_time": "hora de salida de carga",
    "related_shipping_quantity/pcs": "cantidad de envío relacionado/piezas",
    "scan_quantity/pieces": "cantidad de escaneo/piezas",
    "person_responsible_for_shipping": "persona responsable de envío",
    "shipping_car_number": "número de coche de envío",
    "secondary_shipment_number": "número de envío secundaria",
    "secondary_shipping/secondary_outer_carton_label": "envío secundaria/etiqueta de caja exterior secundaria",
    "successful_scan_parts": "piezas de escaneo exitoso",
    "parts_without_scanning": "piezas sin escaneo",
    "download_authorization": "descargar autorización",
    "print_output_sheet": "imprimir hoja de salida",
    "overload_attachment_information": "Información de adjunto recargada",
    "export_output_sheet": "exportar hoja de salida",
    "Create_delivery_list": "Hoja de salida recién construida",
    "title": "Título",
    "Total": "Piezas totales",
    "related_shipping_quantity": "Cantidad coherente de envío",
    "successful_number": "Piezas escaneadas",
    "reject_number": "Piezas rechazadas",
    "intercept_number": "Piezas detenidas",
    "creator": "Fundador",
    "address": "Dirección",
    "Create_time": "Tiempo de creación",
    "Delivery_time": "Tiempo de envíar cajas a bodega ",
    "remark": "Nota",
    "driving": "Manejo",
    "view": "Chequear",
    "delete": "Eliminar",
    "Are_you_sure_to_delete": "Seguro que eliminar?",
    "confirm": "Sí",
    "cancel": "Cancelar",
    "waiting_for_out_warehouse": "Pendiente de salida ",
    "warehousing": "Están saliendo las cargas ",
    "warehoused": "Se han salido las cargas",
    "out_warehouse_abnormally": "Salida anormal de cargas",
    "deleting": "Está eliminando",
    "Successfully_delete": "Eliminar exitosamente",
    "Delete_unsuccessfully": "Eliminar falsamente",
    "Failed_to_get_out_warehouse_list": "Falsamente obtener lista de salida",
    "Attached_file": "Archivo de anexo",
    "Only_support": "Solo apoyo ",
    "format": "Formato",
    "upload": "Subir",
    "save": "Guardar",
    "saving": "Está guardando",
    "Save_successfully": "Guardar exitosamente",
    "Save_unsuccessfully": "Guardar falsamente",
    "Intercepted_number_of_out_warehouse": "Piezas detenidas de salida",
    "Scan_list": "Lista de escaneo",
    "batch_out_warehouse": "Salida por lotes",
    "destroy_goods": "Solicitud de destrucción de bienes",
    "out_warehouse_intercept": "Detener las cargas de salida",
    "Are_you_sure_to_out_warehouse?": "Seguro en salida?",
    "File_list": "Lista de archivos",
    "batch_download": "Descargar por lotes",
    "take_a_photo_and_send_back": "Tomar foto y devolverla",
    "Download": "Descargar",
    "close": "Cerrar",
    "Reject_list": "Lista de rechazo",
    "reject_reason": "Razón de rechazo",
    "filter": "Filtro",
    "reset": "Reiniciar",
    "edit": "Editar",
    "Download_attachment": "Descargar anexo",
    "Update_attachment": "Actualizar anexo",
    "Export_the_reject_list": "Exportar lista de rechazo",
    "All": "Todo",
    "Scanned": "Escaneo hecho",
    "To_be_scanned": "Pendiente de escaneo",
    "rejection": "Rechazo",
    "Failed_to_get_out_warehouse_details": "Falsamente obtener detalles de salida ",
    "Please_check_first": "Marque primero",
    "Batch_delivery_successfully": "Salida exitosa por lotes",
    "Batch_out_warehouse_unsuccessfully": "Salida falsa por lotes",
    "Failed_to_get_fileList": "Falsamente obtener lista de archivo",
    "File_is_empty": "Archivo está vacio",
    "Download_successfully": "Descargar exitosamente",
    "Download_unsuccessfully": "Descargar falsamente",
    "Failed_to_get_scan_list": "Falsamente obtener lista de escaneo",
    "The_attached_file_is_empty": "Archivo de anexo está vacio",
    "exporting": "Está exportando",
    "Export_successfully": "Exportar exitosamente",
    "Export_unsuccessfully": "Exportar falsamente",
    "Print_unsuccessfully": "Imprimir falsamente",
    "printing": "Está imprimiendo ",
    "Print_successfully": "Imprimir exitosamente",
    "intercept_reason": "Razón detenida",
    "intercepting": "Se está impidiendo la salida",
    "Intercept_successfully": "Exitosamente se impidió la salida",
    "Intercept_unsuccessfully": "Falsamente se impidió la salida",
    "Edit_reject_reason": "Editar razón de rechazo",
    "editing": "Están editando",
    "Edit_successfully": "Editar exitosamente",
    "Edit_failure": "Editar falsamente",
    "Please_upload_the_attached_file": "Suba archivo de anexo por favor",
    "updating": "Está actualizando",
    "Update_successfully": "Actualizar exitosamente",
    "Export_warehouse_orders_in_batches": "Exportación masiva de órdenes de salida",
    "Number_of_pieces_to_be_issued": "Número de piezas a emitir",
    "Platform": "plataforma",
    "Export_excel_data_in_batches": "Exportar datos Excel en lotes",
    "Export_the_pdf_of_the_swap": "Exportar PDF con cambio de marca",
    "Change_label_list": "Lista de cambio de etiqueta",
    "Change_label_information_table": "Tabla de información sobre el cambio de etiqueta",
    "Error_table_of_label_change_information": "Tabla de errores de información sobre cambios de etiquetas",
    "List_of_unchanged_labels": "Lista de etiquetas sin cambio",
    "Storage_location_area": "Zona de ubicación de almacenamiento",
    "change_label_status": "Cambio del estado de la etiqueta",
    "operator": "operador",
    "Error_cause": "Causa de Error",
    "Estimated_weight": "Peso estimado",
    "Estimated_volume": "Volumen estimado",
    "abnormal_remark": "Observación anormal",
    "Number_of_items_that_should_be_shipped_out": "Número de artículos que deben ser enviados",
    "Number_of_items_that_have_been_shipped_out": "Número de artículos que han sido enviados",
    "Number_of_items_that_have_not_been_shipped_out": "Número de artículos que no han sido enviados",
    "Number_of_intercepted_items": "Número de artículos interceptados",
    "Number_of_rejected_items": "Número de artículos rechazados",
    "Number_of_items_that_should_have_outer_box_labels_changed": "Número de artículos que deberían haber cambiado las etiquetas de la caja exterior",
    "Number_of_items_that_have_not_had_outer_box_labels_changed": "Número de artículos que no han cambiado las etiquetas de la caja exterior",
    "Batch_processing_abnormal_child_orders": "Procesamiento por lotes de pedidos secundarios anormales",
    "Appendix_to_authorization": "Apéndice de la autorización",
    "Changing_attachment": "Apéndice de cambio de etiqueta",
    "Edit_Excel_Content": "Editar contenido de Excel",
    "Multiple_separated_by_Chinese_commas": "Múltiples separados por comas chinas, por ejemplo:",
    "Old_shipment_number_information": "Información sobre el número de envío anterior",
    "Please_enter_remarks": "Por favor, ingrese comentarios",
    "Update_failure": "Error de actualización",
    "Please_wait_until_the_file_is_uploaded": "Por favor, espere hasta que el archivo se haya cargado completamente",
    "Edit_SKU": "Editar SKU",
    "replace_SKU_or_not": "¿Reemplazar SKU o no",
    "Change_total_quantity": "Cambiar cantidad total",
    "Old_SKU": "SKU antiguo",
    "New_SKU": "SKU nuevo",
    "Update_total_quantity": "Actualizar cantidad total de reemplazos",
    "Add": "Agregar",
    "Confirm": "Confirmar",
    "change": "Reemplazar",
    "Do_not_replace": "No reemplazar",
    "Please_Enter_Old_SKU": "Ingrese el SKU antiguo",
    "Please_Enter_New_SKU": "Ingrese el SKU nuevo",
    "Please_Enter_Total_Replacement_Quantity": "Ingrese la cantidad total de reemplazos",
    "Total_Replacement_Quantity_Cannot_Be_Less_Than_0": "La cantidad total de reemplazos no puede ser menor que 0",
    "The_List_Cannot_Be_Empty": "La lista no puede estar vacía",
    "Please_Enter_Quantity": "Ingrese la cantidad",
    "Quantity_Cannot_Be_Less_Than_0": "La cantidad no puede ser menor que 0",
    "quantity_of_SKU_replacements": "Cantidad de reemplazos de SKU",
    "Suspend_the_responsible_party_from_the_warehouse": "Suspender la parte responsable de la salida del almacén",
    "Delivery_omission": "Omisión en entrega al almacén",
    "Cancel_intercept": "Cancelar intercepción",
    "Cancel_delivery_omission": "Cancelar omisión en entrega",
    "client": "Cliente",
    "staff": "Personal",
    "reason": "Razón",
    "Cancel_intercept_processing": "Cancelando intercepción en proceso",
    "Cancel_intercept_successfully": "Intercepción cancelada con éxito",
    "Failed_to_cancel_intercept": "Fallo en el cancelación de la intercepción",
    "Delivery_missing_processing": "Procesando omisión en entrega al almacén",
    "Delivery_of_missing_processing_completed": "Procesamiento de omisión en entrega al almacén completado",
    "Failed_to_send_warehouse_missing_processing": "Fallo en el procesamiento de omisión en entrega al almacén",
    "Cancel_delivery_missing": "Cancelando omisión en entrega al almacén",
    "Cancel_delivery_missing_complete": "Cancelación de omisión en entrega al almacén completa",
    "Failed_to_cancel_delivery_omission": "Fallo en el cancelación de omisión en entrega",
    "Setting_an_account_failed": "Fallo en la configuración de la cuenta de salida",
    "Set_the_account_successfully": "Configuración de la cuenta de salida realizada correctamente",
    "Change_the_shipment_number": "Cambiar el número de envío para cambiar etiquetas",
    "Shipment_number_information": "Información del número de envío",
    "Charge_Off": "Carga fuera (contabilización)",
    "Set_up_an_account": "Configurar cuenta de salida",
    "Number_of_delivery_pieces": "Número de piezas entregadas",
    "Not_Set": "No configurado",
    "Outstanding_account": "Cuenta pendiente (aún no cargada)",
    "Out_of_account": "Cuenta cargada/liquidada",
    "Check_SKU": "Ver SKU",
    "Change_mark_or_not": "¿Cambiar etiqueta?",
    "Total_number_of_label_changes": "Total de cambios de etiqueta",
    "Actual_number_of_label_changes": "Número real de cambios de etiqueta",
    "Number_of_repeated_label_changes": "Número de cambios de etiqueta repetidos",
    "old_sku": "SKU antiguo",
    "new_sku": "SKU nuevo",
    "allNum": "Cantidad total",
    "Label_the_outer_box_repeatedly": "Etiquetar repetidamente la caja exterior",
    "Cancel_the_repeated_labeling_of_the_outer_box_label": "Cancelar la etiquetado repetido de la caja exterior",
    "Whether_to_set_repeat_replacement": "¿Configurar reemplazo repetido?",
    "The_outer_box_label_does_not_actually_change_the_label": "La etiqueta de la caja exterior realmente no cambia la etiqueta",
    "Cancel_the_outer_box_label_actually_do_not_change_the_label": "Cancelar la opción de que la etiqueta de la caja exterior realmente no cambia la etiqueta",
    "Set_the_actual_SKU_replacement_information": "Configurar la información de reemplazo real del SKU",
    "If_the_label_has_been_changed_before,_set_the_actual_number_of_label_changes": "Si la etiqueta ya ha sido cambiada antes en el pedido de salida, por favor configure el número real de etiquetas cambiadas",
    "Label_change_repeatedly": "Cambio de etiqueta repetido",
    "Repeated_switching": "Cambio de etiqueta repetido",
    "No_repeated_label_change": "Sin cambio de etiqueta repetido",
    "Document_source": "Origen de presentación",
    "TC_Order_for_goods": "TC orden",
    "Straddle_horse": "Cruce de caballos",
    "Latin_horse": "Caballo latino",
    "Export_the_outbound_order_for_the_secondary_partition": "Exportar albarán de salida de subparticiones de segundo nivel",
    "Export_pdf_test": "Exportar PDF (Prueba)",
    "Export_pdf_test2": "Exportar PDF (prueba 2)",
    "Update_remarks": "Actualizar comentarios",
    "Export_the_cargo_trajectory_information_of_Mercadolix": "Exportar información de la trayectoria de la mercancía de Mercadolix",
    "Create_a_new_extraction_label": "Crear nueva etiqueta de extracción",
    "filename": "Nombre de archivo",
    "extract": "extraer",
    "Delivery_date": "Fecha de entrega al almacén",
    "file_type": "Tipo de archivo",
    "Edit_tag_number": "Editar número de etiqueta",
    "Box_label_type": "Tipo de etiqueta de caja",
    "Extraction_in_progress": "Extracción en curso",
    "Extraction_successful": "Extracción exitosa",
    "Extraction_failure": "Fallo de extracción",
    "pagination": "Número de páginas",
    "pageNumber": "Número de página",
    "picture": "imagen",
    "Tag_number": "Número de etiqueta",
    "PDF_link": "Enlace de PDF",
    "Please_enter_the_label": "Por favor, ingrese la etiqueta",
    "add_label": "añadir etiqueta",
    "Merge_and_export_pdf_tags": "Combinar y exportar etiquetas de PDF",
    "Add_mode": "Modo de adición",
    "Add_source": "Fuente de adición",
    "Export_the_label_of_the_first_level_partition_split_box": "Exportar etiqueta de la caja de división de partición de primer nivel",
    "Update_title": "Actualizar título",
    "Page_rectangular_box_cropping": "Recortar caja rectangular de página",
    "clip": "Recortar",
    "no_clip": "No recortar",
    "Batch_download_the_label_of_the_first_level_partition_split_box": "Descargar en lote la etiqueta de la caja de división de partición de primer nivel",
    "Label_type": "Tipos de etiquetas",
    "Upload_the_segmented_file": "Subir archivos divididos",
    "Ordinary_upload": "Subido por común",
    "Special_Upload": "Subida especial",
    "Clear_uploaded_files": "Vaciar archivos cargados",
    "Confirm_the_division": "Determinar la segmentación",
    "Label_preview_image": "Visualización previa de etiquetas",
    "Draggable_or_clickable": "Arrastre o haga clic",
    "Segmentation_failed": "Fracaso de segmentación",
    "Segmentation_completed": "División completa",
    "Unable_to_obtain_the_file_address": "No se puede obtener la dirección del archivo",
    "Filter_by_page_content": "Filtrar por contenido de página",
    "filter": "filtrar",
    "no_filter": "sin filtrar",
    "Please_delete_the_files_that_failed_to_be_split": "Por favor, elimine los archivos que fallaron en la división",
    "Total:": "En total",
    "zhang": "zhang",
    "A_copy": "UN",
    "The_number_of_items_rejected_from_the_warehouse": "Número de artículos rechazados al salir del almacén",
    "container_number": "Número de contenedor",
    "loading_count": "Cantidad de carga",
    "scan_detail": "Detalles del escaneo",
    "Failed_to_get_scan_detail": "Falló la obtención de detalles del escaneo",
    "Edit_the_cabinet_number_and_remarks": "Editar el número de contenedor y las notas",
    "Average_inventory_age": "Edad promedio del inventario",
    "Inventory_age_distribution": "Distribución por edad del inventario",
    "Inventory_age_ranking": "Clasificación por edad del inventario",
    "Customer_goods_in_warehouse_quantity_ranking": "Clasificación por cantidad de mercancías del cliente en almacén",
    "Interval_days": "Intervalo (días)",
    "quantity_in_stock": "Cantidad en stock",
    "Ratio": "Proporción",
    "loading": "Cargando",
    "no_more_data": "No hay más datos",
  },
  order: {
    "exchange_number": "número de cambio",
    "cargo_departure_time": "hora de salida de carga",
    "cargo_exit_hold": "bodega de salida de carga",
    "charge_output_state": "estado de salida de carga",
    "type_of_transport": "tipo de transporte",
    "pick_up_order_number/container_number": "número de recoger pedido/número de contenedor",
    "shipping_time": "hora de envío",
    "status_of_receiving_products": "estado de recibir productos",
    "cargo_access_code": "código de ingreso de carga",
    "load_exit_code": "código de salida de carga",
    "time_to_remove_containers": "hora de retirar contenedores",
    "cargo_entry_time": "hora de ingreso de carga",
    "warehouse_management": "manejo de almacén",
    "old_reserve_area": "área de reserva antiguo",
    "reserve_area_now": "área de reserva ahora",
    "secondary_shipment_number": "número de envío secundaria",
    "new_secondary_shipping_number": "número de envío secundaria nueva",
    "shipping_new/label": "envío nuevo/etiqueta",
    "length": "longitud",
    "width": "ancho",
    "height": "altura",
    "export_sheet": "exportar hoja",
    "export_outer_box_label": "exportar etiqueta de caja exterior",
    "export_corresponding_secondary_shipping_sheet": "exportar hoja de envío secundaria correspondiente",
    "export_corresponding_secondary_shipment/outer_box_label": "exportar envío secundaria correspondiente/etiqueta de caja exterior",
    "delivery_number": "número de envío",
    "shipping/outer_box_label": "envío/etiqueta de caja exterior",
    "export_data": "exportar datos",
    "filter": "filtro",
    "reboot": "reinicio",
    "total_pieces/piece": "piezas totales/pieza",
    "total_volume/cubic_meters": "volumen total/metros cúbicos",
    "total_weight/kg": "peso toal/kilogramo",
    "state": "estado",
    "handling": "manejo",
    "Check": "revisar",
    "volume/cubic_meters": "volumen/metros cúbicos",
    "weight/kg": "peso/kilogramo",
    "total_pieces": "piezas totales",
    "total_weight": "peso total",
    "total_volume": "volumen total",
    "piece": "pieza",
    "Company_logo": "Empresa logo",
    "Cargo_status": "Estado de mercancías"
  },
  container: {
    "Print_partition_code": "Código de la partición de la impresión",
    "add_new_container": "agregar recipiente nuevo",
    "add": "agregar",
    "delivery_number": "número de envío",
    "container_code": "código de recipiente",
    "secondary_shipping/secondary_outer_carton_label": "envío secundaria/etiqueta de caja exterior secundaria",
    "volume": "volumen",
    "edit": "editar",
    "delete": "eliminar",
    "close": "cerrar",
    "discharge": "descargar",
    "Cancel": "cancelar",
    "confirm_on_delete_container": "confirmar en eliminar recipiente ",
    "edit_container": "editar recipiente",
    "container_name": "nombre de recipiente",
    "save": "guardar ",
    "export_data": "exportar datos",
    "filter": "filtro",
    "reboot": "reinicio",
    "total_pieces": "piezas totales",
    "related_shipping_quantity/pcs": "cantidad de envío relacionado/piezas",
    "secondary_shipment_number": "número de envío secundaria",
    "cargo_access_code": "código de ingreso de carga",
    "piece": "pieza",
    "print_container_code": "Imprimir código de envse",
    "select_all": "Selecionar todo",
    "Container_log": "Logs de contenedores",
    "batch_delete": "Eliminación de lote",
    "Transfer_record": "Registro de transferencia",
    "Large_area_code": "Código de área grande",
    "pre_transfer": "pre-transferencia",
    "post_transfer": "post-transferencia",
  },
  abnormalData: {
    "delivery_number": "número de envío",
    "driving_type": "tipo de manejo",
    "cargo_entry_time": "hora de ingreso de carga",
    "shipping/outer_box_label": "envío/etiqueta de caja exterior",
    "Operating_deadline": "fecha límite de manejo",
    "pieces_uploaded_without_scanning": "piezas subidas sin escaneo",
    "paste_label": "pegar etiqueta",
    "customers": "clientes",
    "Salesman": "vendedor",
    "secondary_shipment_number": "número de envío secundaria",
    "product_label": "etiqueta de productos",
    "load_output_number": "número de salida de carga",
    "cargo_departure_time": "hora de salida de carga",
    "time_to_remove_containers": "hora de retirar contenedores",
    "related_shipping_quantity/pcs": "cantidad de envío relacionado/piezas",
    "Warehouse_output_quantity/pieces": "cantidad de salida de bodega/piezas",
    "amount_of_strange": "cantidad de extraño",
    "successful_scan_parts": "piezas de escaneo exitoso",
    "parts_without_scanning": "piezas sin escaneo",
    "person_responsible_for_shipping": "persona responsable de envío",
    "shipping_car_number": "número de coche de envío",
    "secondary_shipping/secondary_outer_carton_label": "envío secundaria/etiqueta de caja exterior secundaria",
    "quantity_of_products/pieces": "cantidad de productos/piezas",
    "cargo_entry_number": "número de ingreso de carga",
    "warehouse_receipt_amount/piece": "cantidad de ingreso de bodega/pieza",
    "pieces_of_strange": "piezas de extraño",
    "pieces_without_charge_entry": "piezas sin ingreso de carga",
    "type_of_transport": "tipo de transporte",
    "pick_up_order_number/container_number": "número de recoger pedido/número de contenedor",
    "Data_export": "Exportar datos",
    "filter": "Filtro",
    "reset": "Reiniciar",
    "piece": "/Pieza",
    "Total_volume": "Volumen total",
    "Total_weight": "Peso total",
    "driving": "Manejo",
    "view": "Chequear",
    "out_warehouse_number": "Número de hoja de salida",
    "title": "Título",
    "status": "Estado",
    "Total": "Piezas totales",
    "reject_number": "Piezas rechazadas",
    "intercept_number": "Piezas detenidas",
    "creator": "Fundador",
    "address": "Dirección",
    "create_time": "Tiempo de creación",
    "delivery_time": "Tiempo de enviar cajas a bodega",
    "remark": "Nota",
    "delete": "Eliminar",
    "Are_you_sure_to_delete": "Seguro que eliminar?",
    "cancel": "Cancelar",
    "waiting_for_out_warehouse": "Pendiente de salida",
    "warehousing": "Está saliendo",
    "warehoused": "Se han salido ",
    "out_warehouse_abnormally": "Salida anormal de carga",
    "deleting": "Está eliminando ",
    "Successfully_deleted": "Eliminar exitosamente",
    "Failed_to_get_out_warehouse_list": "Falsamente obtener lista de salida",
    "Deletion_failure": "Eliminar falsamente",
    "Scan_list": "Lista de escaneo",
    "batch_delivery": "Salida por lotes",
    "out_warehouse_intercept": "Salida detenida",
    "Are_you_sure_to_out_warehouse?": "Seguro en salida?",
    "File_list": "Lista de archivos",
    "batch_download": "Descargar por lotes",
    "take_a_photo_and_send_back": "Tomar foto y devolverla ",
    "download": "Descargar",
    "close": "Cerrar",
    "Reject_list": "Lista de rechazo",
    "download_attachment": "Descargar anexo",
    "edit": "Editar",
    "update_attachment": "Actualizar anexo",
    "print_out_warehouse_list": "Imprimir hoja de salida",
    "export_out_warehouse_list": "Exportar hoja de salida",
    "Export_the_reject_list": "Exportar lista de rechazo",
    "all": "Todo",
    "Scanned": "Escaneo hecho",
    "To_be_scanned": "Pendiente de escaneo",
    "rejection": "Rechazo",
    "Failed_to_get_out_warehouse_details": "Falsamente obtener detalles de salida ",
    "Failed_to_get_scan_list": "Falsamente obtener lista de escaneo",
    "Please_check_first": "Marque primero",
    "Batch_delivery_successfully": "Salida exitosa por lotes",
    "Batch_out_warehouse_unsuccessfully": "Salida falso por lotes",
    "Failed_to_get_fileList": "Falsamente obtener lista de archivo",
    "File_is_empty": "Archivo está vacio",
    "Download_unsuccessfully": "Descarga falsa",
    "Download_successfully": "Descarga exitosa",
    "The_attached_file_is_empty": "Archivo de anexo está vacio",
    "exporting": "Está exportando",
    "Export_successfully": "Exportación exitosa",
    "Export_unsuccessfully": "Exportación falsa",
    "intercept_reason": "Razón detenida",
    "intercepting": "Se está impidiendo la salida",
    "Intercept_successfully": "Exitosamente se impidió la salida",
    "Edit_reject_reason": "Editar razón de rechazo",
    "reject_reason": "Razón de rechazo",
    "editing": "Están editando",
    "Edit_successfully": "Editar exitosamente",
    "Edit_failure": "Editar falsamente",
    "Update_attachment": "Actualizar anexo",
    "Please_upload_the_attached_file": "Suba archivo de anexo por favor",
    "Only_xls,_xlsx,_PDF_files_are_supported": "Solo apoyo para archivo xls, xlsx, PDF",
    "updating": "Está actualizando",
    "Update_successfully": "Actualizar exitosamente",
    "Intercept_unsuccessfully": "Falsamente se impidió la salida",
    "Failed_to_get_warehousing_list": "Falsamente obtener lista de ingreso",
    "warehoused_number": "Piezas de carga ingresada ",
    "volume": "Volumen total/metros cúbicos",
    "weight": "Peso/kilogramo",
    "Failed_to_get_warehousing_details": "Falsamente obtener detalles de ingreso",
    "confirm": "Sí",
    "save": "Guardar",
    "Intercepted_number_of_out_warehouse": "Piezas detenidas de salida",
    "Warehouse_area": "Área de almacén",
    "uploader": "La persona que lo subió",
    "Upload_time": "Tiempo de carga",
    "picture": "fotografía",
    "TC_sub-order_number": "Número subúnico de CT",
    "secondary_shipping": "Número de envío para niños",
    "modifier": "Modificar a la persona",
    "modifier_time": "Tiempo de modificación",
    "edit_order_number": "Editar el número de seguimiento",
    "please_enter_the_sub-order_number": "Introduce el número de subpedido",
    "please_enter_the_secondary_shipping": "introduce el número de subenvío",
  },
  baseSetting: {
    "add": "agregar",
    "brand": "marca",
    "boss/responsible_person": "jefa/persona responsable",
    "administrator": "administrador",
    "edit": "editar",
    "Delete": "eliminar",
    "Sure_to_delete_car_information?": "seguro que eliminar la información de coche?",
    "Confirm": "confirmar",
    "Cancel": "cancelar",
    "add_car_info": "añadir información de coche",
    "car_number": "número de coche",
    "Car_type": "tipo de coche",
    "Purchased_time": "hora de compras",
    "all_people/everyone": "todas las personas/todo el mundo",
    "regulator/administrator": "regulador/administrador",
    "save": "guadar",
    "edit_car_info": "editar información de coche",
    "contact": "contacto",
    "phone_contact": "contacto de teléfono",
    "detailed_address": "dirección detallada",
    "add_classification_area": "añadir área de clasificación",
    "secondary_sorting_quantity/pieces": "cantidad de clasificación secundaria/piezas",
    "number_of_pallets/pieces": "cantidad de tarima/piezas",
    "maximum_capacity/cubic_meters": "capacidad máxima/metros cúbicos",
    "sure_to_delete_area_F?": "seguro de eliminar área F?",
    "classification_name": "nombre de clasificación",
    "maximum_capacity": "capacidad máxima",
    "edit_warehouse_information": "editar información de bodega",
    "warehouse_name": " numbre de bodega",
    "secondary_classification_area": "área de clasificación secundaria",
    "add_secondary_sort_area": "añadir área de clasificación secundaria",
    "location_code": "código de ubicación",
    "capacity_now": "capacidad ahora",
    "Carboard": "tarima",
    "Add_carboard": "añadir tarima",
    "Carboard_code": "código de tarima",
    "Edit_carboard": "editar tarima",
    "Carboard_name": "nombre de tarima",
    "edit_secondary_sort_area": "editar área de clasificación secundaria",
    "secondary_sort_area_name": "nombre de área de clasificación secundaria",
    "close": "cerrar",
    "download": "descargar",
    "Total_number_of_pieces": "Número total de piezas",
    "shipping": "envío",
    "delivery_number": "número de envío",
    "secondary_shipment_number": "número de envío secundaria",
    "sure_to_delete": "seguro de eliminar",
    "area": "área",
    "Number_of_subarea": "cantidad de área clasificada/piezas",
    "Edit_subarea": "editar área clasificada",
    "Old_shipment_number": "número de envío viejo",
    "scanning_time": "fecha de escaneo",
    "shelf": "Estantes",
    "Add_shelf": "Añadir estantes",
    "Export_the_required_location_code_size": "Exportar las dimensiones del código de ubicación necesarias",
    "Export": "Exportar",
    "Number_of_layers": "Número de capas",
    "Add_layers": "Agregar el número de capas",
    "location": "Ubicación del contenedor",
    "Add_location": "Agregar una ubicación de contenedor",
    "Failed_to_get_the_warehouse_shelf_list": "Error al obtener la lista de estantes del almacén",
    "Failed_to_get_the_layer_number_of_warehouse_list": "Error al obtener la lista de niveles de almacén",
    "Failed_to_get_the_warehouse_location_list": "Error al obtener la lista de ubicaciones de almacén",
    "print": "Imprimir",
    "Select_All": "Seleccionar todo",
    "All_complete": "Seleccionar todo para completar",
    "Please_select_the_print_item_first": "Por favor, compruebe primero el elemento impreso",
  },
  deliveryReservation: {
    "Daily_Reservation": "Reserva al día ",
    "Last_month": "el mes pasado",
    "today": "hoy",
    "Next_month": "el mes que viene",
    "Reservation_status": "proceso de reserva",
    "piece": "pieza",
    "Daily_delivery": "envío a bodega cada día",
    "Delivery_instructions": "Instrucciones de bodega",
    "Reservation_time": "tiempo de reserva",
    "Delivery_time": "tiempo de envío ",
    "Shipment_number/shipping_mark": "número de envío/etiqueta de caja exterior",
    "pieces": "piezas",
    "Cancel_delivery": "cancelar envío",
    "Confirm_whether_to_cancel_delivery": "seguro en cancelar envío?",
    "Successfully_cancel_delivery": "Cancelar envío exitosamente",
    "Failed_to_cancel_delivery": "Cancelar envío falsamente",
    "Failed_to_get_data": "Falsamente obtener datos",
    "export": "Exportar",
    "exporting": "Está exportando",
    "Export_successfully": "Exportar exitosamente",
    "Export_unsuccessfully": "Exportar falsamente",
    "delivery_number": "número de envío",
    "shipping/outer_box_label": "envío/etiqueta de caja exterior",
    "load_output_number": "número de hoja de salida",
    "filter": "Filtro",
    "reset": "Reiniciar",
    "shipping": "envío",
    "driving": "Manejo",
    "confirm": "Sí",
    "cancel": "Cancelar",
  },
  workorder: {
    "Work_order_number": "Número de billete",
    "Associated_order_number": "Número de seguimiento asociado",
    "Operating_state": "Estado de la operación",
    "work_order_node": "Nodo de billete",
    "Work_order_type": "Tipo de billete",
    "Problem_type": "Tipo de problema",
    "Creation_time": "Hora de creación",
    "creator": "Fundador",
    "Processing_department": "Departamento de Procesamiento",
    "filter": "Cernir",
    "reset": "Reconstituir",
    "customer_code": "Código de cliente",
    "Current_processing_department": "Departamento de procesamiento actual",
    "Current_processor": "Procesador actual",
    "Associated_work_order": "Tickets de asociados",
    "Current_node_time": "El nodo actual ha transcurrido",
    "Total_time_spent": "Tiempo total consumido",
    "Claim_time": "Tiempo de reclamo",
    "Prescription_of_claim": "Estatuto de limitaciones de la reclamación",
    "Operating_time": "Tiempo de operación",
    "Description": "Describir",
    "remark": "Notar",
    "Latest_communication_content": "Comunicaciones actualizadas",
    "view": "Examinar",
    "All": "Total",
    "Wait_to_be_done": "Próximo",
    "Have_done": "Fecho",
    "My_creation": "Mi creación",
    "Copy_me": "Enviado a mí",
    "Withdrawn": "Retirado",
    "rejected": "Rechazado",
    "submitted": "Presentado",
    "finished": "Finalizado",
    "Obsolete": "Obsolescente",
    "Have_already_been_created": "Creado",
    "In_process": "En procesamiento",
    "Failed_to_get_a_CC": "Error de envío",
    "Failed_to_get_the_work_order_type_list": "Error al obtener la lista de tipos de tickets",
    "Failed_to_get_the_problem_type_list": "Error al obtener la lista de tipos de problemas",
    "Failed_to_get_the_department_list": "Error al obtener la lista de departamentos",
    "Failed_to_get_the_employee_list": "Error al obtener la lista de empleados",
    "Failed_to_get_the_work_order_list": "Error al obtener obtener la lista de boletos",
    "Failed_to_change_cc_status": "Error al enviar el cambio de estado",
    "Basic_information": "Información básica",
    "View_the_change_mark_requirements": "Revisar los requisitos de reetiquetado",
    "Attached_file": "Documentos adjuntos",
    "Attached_picture": "Fotos adjuntos",
    "Processing_information": "despahca información",
    "Whether_to_view": "Si ver o no",
    "Owning_warehouse": "Almacén al que pertenece",
    "Communication_information": "Comunicar información",
    "Communication_reply": "Responder información",
    "issuer": "expedidor",
    "Carbon_copy_recipient": "La persona notificada",
    "Communication_content": "Contenido de la comunicación",
    "Claim_the_work_order": "Reclama tickets",
    "Processing_work_order": "Procesar tickets",
    "Work_order_processing_log": "Registros de procesamiento de tickets",
    "unfold": "desplegar",
    "handle": "despachar",
    "Pack_up": "colapsar",
    "processor": "Controladores",
    "Check_the_time": "Consulta la hora",
    "Node_time_consuming": "El tiempo que tarda el nodo",
    "Processing_remarks": "Trabajar con notas",
    "Are_you_sure_you_want_to_claim_a_work_order?": "¿Está seguro de que desea reclamar un boleto?",
    "confirm": "definir",
    "Cancel": "cancelar",
    "Are_you_sure_you_want_to_complete_a_work_order?": "¿Estás seguro de que quieres cerrar tu ticket?",
    "source": "origen",
    "Whether_internal_work_order": "Si es o no un ticket interno",
    "initiator": "iniciador",
    "Commit_processing": "Envío para procesamiento",
    "Finished_work_order": "Ticket de trabajo completa",
    "Withdrawal_processing": "Retirada del tratamiento",
    "Scrap_ticket": "Tickets de trabajo abandandos",
    "Failed_to_get_domain_name": "Error al obtener el nombre de dominio",
    "Failed_to_get_details": "Error al obtener detalles",
    "Failed_to_get_chat_list": "Error al  obtener la lista de chat",
    "Failed_to_get_the_log_list": "Error al obtener la lista de registros",
    "Reason_for_withdrawal": "Motivo del desistimiento",
    "Cause_of_rejection": "Motivo del rechazo",
    "Reason_for_abandonment": "Motivo del abandono",
    "Claiming": "Reclamando",
    "Claim_successfully": "Reclamación exitosa",
    "Failed_to_claim_the_work_order": "Erro al reclamar el boleto",
    "In_completion": "completando",
    "Complete_success": "Completado con éxito",
    "Failed_to_complete_the_work_order": "Error al cerrar el ticket",
    "Number_of_packages": "Número ",
    "Shipping_slip_number": "Número de albarán",
    "Old_shipment_number": "Número de envío antiguo",
    "Shipping_mark": "Marcas",
    "New_shipment_number": "Nuevo número de envío",
    "Old_SKU_logo": "Antigua etiqueta de SKU",
    "New_SKU_logo": "Nueva etiqueta de SKU",
    "Please_fill_in": "Por favor, rellene",
    "required": "Obligatorio",
    "Picture_upload": "Subir foto",
    "Only_support": "Solo compatible",
    "isoformat": "y otros formatos de imagen",
    "Being_submitted": "En presentación",
    "Submit_successfully": "Presentación exitosa",
    "Commit_failure": "Presentación fallida",
    "Processing_result": "Procesar los resultados",
    "Failed_to_obtain_the_service_provider_list": "Error al obtener la lista de proveedores de servicios",
    "task_code": "Código de tarea",
    "Export_mark_handover": "Exportar entrega de cambio de etiqueta",
    "Batch_assignment_work_order": "Asignación por lotes de órdenes de trabajo",
    "Added_to_download_list": "Añadido a la lista de descargas",
    "excel_export_failed": "Exportación de Excel fallida",
    "Bind_suborders_in_batches": "Bulk bonding subórdenes",
    "Confirm_binding": "Confirmar enlace",
    "Processing_priority": "Prioridad de procesamiento",
    "Batch_export_of_goods_details": "Bulk export detalles de carga",
  },
  error: {
    "Sorry_the_page_you_are_looking_for_is_missing": "Lo sentimos, faltaba la página que intentabas visitar",
    "To_check_whether_the_URL_you_entered_is_correct_please_click_the_button_below_to_return_to_the_home_page": "Compruebe que ha introducido la URL correcta, haga clic en el botón de abajo para volver a la página de inicio",
    "Back": "Regresar"
  },
  loadingLot: {
    "delivery_number": "número de envío",
    "shipping": "envío",
    "creator": "Fundador",
    "End_time_of_scanning_code": "Tiempo final del código de barrido",
    "car_number": "número de coche",
    "filter": "Filtro",
    "reset": "Reiniciar",
    "driving": "Manejo",
    "view": "Examinar",
    "batch_export": "Exportar en lotes",
    "lot_number": "Número de lote",
    "Number_of_packages": "Número",
    "Create_time": "Tiempo de creación",
    "export_data": "exportar datos",
    "lot_information": "Información del lote",
    "total_pieces": "piezas totales",
    "Code_scanner": "Barrido de código hombre",
    "Shipment_information": "Información de piezas",
    "Code_scanning_information": "Información del código de barrido",
    "Code_scanning_failure_information": "Mensaje de error del código de barrido",
    "tc_order_number": "Número de pedido de TC",
    "Shipment_number": "Número de envío",
    "Number_of_items_to_be_shipped_out": "Número de piezas que deben salir del almacén",
    "Number_of_scanned_codes": "Número de piezas de barrido",
    "Missing_pieces": "Falta número de piezas",
    "Missing_number": "Número que falta",
    "TC_sub-order_number": "Número subúnico de CT",
    "secondary_shipping": "Número de envío para niños",
    "scanning_time": "fecha de escaneo",
    "Cause_of_failure": "Causas del fracaso",
    "transport_car_no": "Matrícula del vehículo",
    "create_user_realname": "Creador",
    "create_time": "Fecha de creación",
    "number": "Número de lote",
    "scan_count": "Número de documentos escaneados"
  },
  returnGoods: {
    "Generate_a_single_barcode": "Generar un código de barras único",
    "Batch_barcode_generation": "Generación de código de barras por lotes",
    "Shipment_number/shipping_mark": "Número de envío/marca de envío",
    "Input_example": "Ejemplo de entrada",
    "Please_enter": "Por favor introduzca",
    "Start_number": "Número de inicio",
    "End_number": "Número final",
    "Shipping_mark_delimiter": "Marca de envío delimiter",
    "If_the_number_is_set_to_1-10,_it_will_be_generated_in_the_form_of_12345-1_to_12345-10": "Si el número se establece en 1-10, se generará en la forma de 12345-1 a 12345-10",
    "Cancel": "cancelar",
    "print": "imprimir",
    "Export": "exportación",
    "None": "ninguno",
    "saving": "ahorro",
    "printing": "Impresión de impresión",
    "Print_successfully": "Impresión con éxito",
    "Failed_to_print": "No se ha podido imprimir",
    "exporting": "exportación",
    "Export_successfully": "Exportar con éxito",
    "Failed_to_export_the_sheet": "No pudo exportar la hoja",
    "Platform_type": "Tipo de plataforma",
    "Return_code": "Código de retorno",
    "Number_of_packages": "Número de paquetes",
    "Add": "añadir",
    "Fill_in_optional": "Completar opcional",
    "Shipment_number": "Número de envío",
    "Delete": "eliminar",
    "Return_goods": "Devolución de mercancías",
    "United_States_and_Mexico": "Estados Unidos y México",
    "Saving": "ahorro",
    "Save_successfully": "Guardar correctamente",
    "Failed_to_save": "No ha podido ahorrar",
    "Failed_to_obtain_the_platform_type_list": "No se pudo obtener la lista de tipos de plataforma",
    "Please_select_the_platform_type!": "Por favor seleccione el tipo de plataforma!",
    "Failed_to_add_the_shipment_number": "No se pudo agregar el número de envío",
    "The_return_code_can_only_be_added_once": "El código de retorno sólo se puede añadir una vez",
    "Please_enter_the_correct_information!": "Por favor, introduzca la información correcta!",
    "adding": "añadir",
    "Add_successfully": "Añadir correctamente",
    "Add_failure": "Fallo adicional",
    "Return/US-Mexico_details": "Return/US-Mexico details (en inglés)",
    "TC_order_number": "Número de pedido TC",
    "Founder": "fundador",
    "Warehousing_time": "Tiempo de almacenamiento",
    "Total_number_of_packages": "Número Total de paquetes",
    "Order_type": "Tipo de pedido",
    "Time_of_creation": "Tiempo de creación",
    "Order_information": "Información de pedido",
    "TC_sub-order_number": "Número de suborden del TC",
    "Sub-shipment_number": "Número de subenvío",
    "Express_tracking_number": "Número de seguimiento Express",
    "Storage_location_information": "Información de ubicación de almacenamiento",
    "The_latest_update_time": "El último tiempo de actualización",
    "Updater": "actualización",
    "Cargo_picture": "Imagen de carga",
    "Print_sheet": "Printhitt",
    "Export_sheet": "Éxito de exportación",
    "Download": "Don Señor",
    "Close": "Cruz",
    "Failed_to_get_details": "Feld Togert De Tails",
    "Failed_to_obtain_form": "Feldto Obtanfom",
    "generate": "Genirat",
    "Express_Ticket_number": "Exprestik Denunbo",
    "New_order": "Nuevoviejo",
    "Type_of_order": "Tapben Odd",
    "Type_of_shipment": "Envío Taipuben",
    "Generate_barcode": "Generar código de barras",
    "View_size": "El tamaño de la vista",
    "resize": "Cambiar el tamaño",
    "Private_person": "Persona privada",
    "Address_template": "Plantilla de direcciones",
    "Upload_packing_list": "Cargar lista de embalaje",
    "Only_files_smaller_than_15_MB_are_supported": "Sólo los archivos menores de 15 MB son soportados",
    "Modify_size_information_in_batches": "Modificar la información del tamaño en lotes",
    "Gross_weight": "Peso bruto",
  },
  inventoryCenter: {
    "Edit_operation_time": "Tiempo de operación de edición",
    "Updated_in_Mexico_local_time": "Actualizado en hora local de México",
    "First_shelf_time_(manual)": "Tiempo de primera estan(manual)",
    "Takedown_time_(manual)": "Tiempo de retirada (manual)",
    "Exit_time_(manual)": "Tiempo de salida (manual)",
    "Warehousing_time_(manual)": "Tiempo de almacenamiento (manual)",
    "Shelf_time": "Tiempo de almacenamiento",
    "Update_the_outbound_time": "Actualizar el tiempo de salida",
    "Outbound_time_(Mexico_time)": "Tiempo de salida (hora México)",
  },
  transferWarehouse: {
    "order_number": "Número de pedido",
    "shipping_mark": "Marca de marca",
    "account_manager": "Administrador de cuentas",
    "reception_time": "Tiempo de recepción",
    "estimated_time_of_delivery": "Tiempo estimado de entrega",
    "order_status": "Estado del pedido",
    "audit_status": "Estado de la auditoría",
    "filter": "Filtro de filtro",
    "reset": "restablecer",
    "operate": "operan",
    "view": "ver",
    "pending": "Pendiente pendiente",
    "audited": "audiaudiaudiaudi",
    "failed_to_get": "El presidente",
    "saving": "ahorro",
    "saved_successfully": "Guardado con éxito",
    "failed_to_save": "No ha podido ahorrar",
    "order_information": "Información de pedido",
    "number_of_pieces": "Número de piezas",
    "creation_time": "Tiempo de creación",
    "shelf_start_time": "Tiempo de inicio",
    "storage_age": "Edad de almacenamiento",
    "finish_shelf_time": "Tiempo de finalización de la estande",
    "place_of_dispatch": "Lugar de expedición",
    "total_weight": "Peso total",
    "receiver": "receptor",
    "destination_warehouse": "Almacén de destino",
    "total_volume": "Volumen total",
    "customer_information": "Información del cliente",
    "customer_name": "Nombre del cliente",
    "contact_person": "Persona de contacto",
    "contact_number": "Número de contacto",
    "shipment_information": "Información sobre envíos",
    "total_actual_weight": "Peso Total efectivo",
    "total_volume(volume_weight)": "Volumen Total (peso en volumen)",
    "total_square(volume)": "Total del cuadrado (volumen)",
    "total_square(actual_weight_divided_by_300)": "Total del cuadrado (peso actual dividido por 300)",
    "total_quantity": "Cantidad Total",
    "shipment_status": "Estado del envío",
    "days_of_storage": "Días de almacenamiento",
    "hide": "ocultar",
    "expand": "ampliar",
    "tc_subtracking_number": "Número de subseguimiento de TC",
    "sub_shipment_number/shipping_mark": "Número de envío/marca de envío",
    "length_*_width_*_height_/cm": "Longitud * anchura * altura /CM",
    "gross_weight_/kg": "Peso bruto /KG",
    "scanned_picture": "La imagen escan",
    "scene_picture": "Cuadro de la escena",
    "sku_name": "SKU el nombre",
    "number_of_single_box": "Número de cajas individuales",
    "view_picture": "Ver la imagen",
    "receive_information": "Recibir información",
    "shipping_contact": "Contacto de envío",
    "shipping_contact_number": "Número de contacto",
    "receive_signature_picture": "Recibir la firma",
    "receive_picture": "Recibir la imagen",
    "repudiator": "repudiator",
    "rejection_time": "Tiempo de rechazo",
    "rejection_instructions": "Instrucciones de rechazo",
    "explanatory_picture": "Cuadro explicativo",
    "remark_information": "información",
    "customer_remarks": "Comentarios del cliente",
    "internal_remarks": "Observaciones internas",
    "print_sheet": "Hojas de impresión",
    "export_sheet": "Hojas de exportación",
    "export_warehouse_list": "Lista de almacenes para exportación",
    "export_customer_box_list": "Cuadro de exportación de clientes",
    "export_customer_service_box_list": "Exportar servicio al cliente box list",
    "export_attachment": "Derecho a la exportación",
    "off": "fuera",
    "download": "descargar",
    "new_sub_shipment_number/shipping_mark": "Nuevo número de envío/marca de envío",
    "change_type": "Cambio de tipo",
    "old_sub_shipment_number/shipping_mark": "Antiguo número de envío/marca de envío",
    "original_product_label": "Etiqueta Original del producto",
    "new_product_label": "Nueva etiqueta del producto",
    "quantity": "La cantidad",
    "change_area": "Zona de cambio",
    "uploading": "Cargar encima de carga",
    "upload_successfully": "Cargar correctamente",
    "failed_to_upload": "No se ha podido cargar",
    "removing": "retirar",
    "removed_successfully": "Eliminado con éxito",
    "failed_to_remove": "No se ha podido eliminar",
    "syncing": "sincronización",
    "sync_successfully": "Sincronización con éxito",
    "failed_to_sync": "No se pudo sincronizar",
    "no_data_available": "No hay datos disponibles",
    "exporting": "exportación",
    "warehouse_list": "Lista de almacén",
    "added_to_the_download_queue": "Añadido a la cola de descarga",
    "failed_to_export": "No export",
    "printing": "Impresión de impresión",
    "print_successfully": "Impresión con éxito",
    "failed_to_print": "No se ha podido imprimir",
    "piece": "La pieza",
    "number_of_packages": "Número de paquetes",
    "express_sheet": "Hojas expresexpresas",
    "reject_information": "Rechazar la información",
    "delivery_information": "Información de entrega",
    "operator": "operador",
    "operate_status": "Estado de funcionamiento",
    "process_time": "Tiempo de proceso",
    "picture": "Imagen de la imagen",
    "remark": "comentario",
    "accept": "aceptar",
    "reject": "rechazo",
    "picture_error,_please_contact_staff!": "Error de imagen, por favor póngase en contacto con el personal!",
    "New_order": "Nuevo pedido",
    "Order_type": "Tipo de pedido",
    "Edit_order_category": "Editar categoría de pedido",
    "Batch_delete": "Eliminar en lotes",
    "Batch_audit": "Auditar en lotes",
    "Batch_counter_audit": "Desauditar en lotes",
    "Are_you_sure_you_want_to_do_a_batch_audit": "¿Seguro que desea realizar la auditoría en lotes?",
    "Are_you_sure_you_want_to_do_a_batch_counter_audit": "¿Seguro que desea realizar la desauditoría en lotes?",
    "add": "Añadir",
    "Delete": "Eliminar",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "delete_remarks": "Eliminar comentarios",
    "I_ll_think_about_it_again": "Voy a pensarlo de nuevo",
    "Submit_successfully": "Enviado correctamente",
    "Commit_failure": "Error en el envío",
    "Please_check_first": "Por favor, seleccione primero",
    "deleting": "Eliminando",
    "Successfully_deleted": "Eliminado correctamente",
    "Deletion_failure": "Error en la eliminación",
    "In_operation": "En operación",
    "operation_succeeded": "Operación completada",
    "operation_failure": "Error en la operación",
    "edit": "Editar",
    "status": "Estado",
    "Warehousing_time": "Fecha de almacenamiento",
    "Subsingle_column_table": "Lista de subpedidos",
    "Number_of_products_tag": "Número de paquete/Etiqueta",
    "son_order_number": "Número de subpedido",
    "export": "Exportar",
    "Total_number_of_packages": "Total de paquetes",
    "Manifest_Agent": "Información del envío",
    "Add_Manifest_Agent": "Añadir información del envío",
    "edit_size": "Editar dimensiones",
    "Upload_customer_service_box_list": "Subir lista de cajas de servicio al cliente",
    "Only_files_smaller_than_15_MB_are_supported": "Solo se admiten archivos de menos de 15 MB",
    "Synchronize_customer_service_box_list": "Sincronizar lista de cajas de servicio al cliente",
    "Are_you_sure_you_want_to_delete": "¿Seguro que desea eliminar?",
    "Failed_to_get_order_classification": "Error al obtener la clasificación de pedidos",
    "Failed_to_get_details": "Error al obtener los detalles",
    "Failed_to_obtain_the_goods_information_Procedure": "Error al obtener la información de la mercancía",
    "Data_acquisition_failure": "Error en la obtención de datos",
    "Failed_to_export_the_sheet": "Error en la exportación de la etiqueta",
    "Customer_contact": "Contacto del cliente",
    "Start_number": "Número de inicio",
    "End_number": "Número de finalización",
    "serial_number": "Número de serie",
    "length_width_height": "LongitudAnchuraAltura",
    "weight": "Peso",
    "add_SKU": "Añadir SKU",
    "Platform": "Plataforma",
    "Batch_modify": "Modificar en lotes las especificaciones de los números de paquete",
    "Length_CM": "Longitud/CM",
    "Width_CM": "Anchura/CM",
    "Height_CM": "Altura/CM",
    "Weight_KG": "Peso bruto/KG",
    "Confirm": "Confirmar",
    "submit_order": "Enviar pedido",
    "adding": "Añadiendo",
    "Lieferumfang": "Número de paquete",
    "unfold": "Expandir",
    "Pack_up": "Replegar",
    "Being_submitted": "Enviando",
    "Failed_to_obtain_the_customer_name_Procedure": "Error al obtener el nombre del cliente",
    "Description_Failed_to_obtain_the_account_manager": "Error al obtener el gerente de cuenta",
    "Failed_to_obtain_the_customer_contact_Procedure": "Error al obtener el contacto del cliente",
    "Failed_to_obtain_contact": "Error al obtener el contacto",
    "Platform_acquisition_failure": "Error al obtener la plataforma",
    "Number_already_exists": "El número ya existe",
    "New_failed": "Error al añadir",
    "Please_select_the_customer_name_first": "Por favor, seleccione primero el nombre del cliente",
    "Failed_to_obtain_customer_details": "Error al obtener los detalles del cliente",
    "Please_enter_SKU_number_or_name_search": "Ingrese el número o nombre de SKU para buscar",
    "sku_code": "Código SKU",
    "selected_sku_count": "Cantidad de SKU seleccionados",
    "Add": "Añadir",
    "aggregate": "Total",
    "true_weight": "Peso real",
    "volumes": "Volumen (peso volumétrico)",
    "Number_of_squares_300": "Volumen (peso real dividido por 300)",
    "Get_the_results": "Obtener resultados",
    "save": "Guardar",
    "Failed_to_obtain_the_calculation_result_Procedure": "Error al obtener el resultado del cálculo",
    "Edit_Customer_information": "Editar información del cliente",
    "contact_person_ensp": "Contacto",
    "Edit_Sizes": "Editar dimensiones",
    "Sub_shipment_number": "Número de subenvío",
    "Failed_to_get_the_SKU_list": "Error al obtener la lista de SKU",
    "upload_attachment": "Subir adjunto",
  },
  other: {
    "batch_intercept": " Intercepción por lotes",
    "view_excel_content": "  Ver contenido de Excel",
    "tc_order_number": "Número de pedido de TC",
    "tc_order_id": "ID de pedido de TC",
    "Shipments_sent_to_Full_or_FBA": "Envíos enviados al Full o FBA",
    "change_mark": "Marca de cambio",
    "hour": "Hora",
    "Export_location_information_(trial)": "Exportar información de ubicación (versión de prueba)",
    "have_joined_downlod_queue": "Se han unido a la cola de Downlod",
    "Edit_information": "Editar información",
    "Confirm_the_changes?": "¿Confirmar los cambios?",
    "Please_enter_search_criteria": "Por favor, introduzca los criterios de búsqueda",
    "search": "buscar",
    "return_claim": "Reclamación de devolución",
    "return_code": "Código de retorno",
    "Shipment_number": "Número de envío",
    "export_multi_subarea_outwarehouse_order_list": "Exportar varias subáreas Lista de pedidos de Outwarehouse",
    "secondary_shipment/outer_box_label": "Envío secundario/etiqueta de caja exterior",
    "pcs": "Pc",
    "Failed_to_get": "No se pudo obtener",
    "Please_enter_the_license_plate_number": "Por favor, introduzca el número de matrícula",
    "Please_select_the_purchase_time": "Por favor, seleccione la hora de compra",
    "Are_you_sure_to_add_another_layer_to_this_shelf?": "¿Está seguro de agregar otra capa a este estante?",
    "Are_you_sure_to_add_a_storage_location_on_this_shelf?": "¿Está seguro de agregar una ubicación de almacenamiento en este estante?",
    "Are_you_sure_to_delete_this_shelf?": "¿Está seguro de eliminar este estante?",
    "Are_you_sure_to_delete_the_maximum_number_of_shelves?": "¿Está seguro de eliminar el número máximo de estanterías?",
    "Are_you_sure_to_delete_this_storage_location?": "¿Está seguro de eliminar esta ubicación de almacenamiento?",
    "Shelf_name": "Nombre del estante",
    "the_number_of_columns_of_location": "El número de columnas de la ubicación de almacenamiento",
    "single": "solo",
    "batch": "lote",
    "Add_a_new_container": "Agregar un nuevo contenedor",
    "Please_enter_the_container_code": "Introduzca el código del contenedor ",
    "The_container_code_is_too_long_Please_re_enter_it": "El código contenedor es demasiado largo. Por favor, vuelva a introducirlo",
    "Add_new_containers_in_batches": "Agregar nuevos contenedores en lotes",
    "quantity": "Cantidad",
    "Please_enter_quantity": "Introduce la cantidad",
    "warehouse": "Almacén",
    "uploading": "Cargando",
    "upload_successfully": "Cargar exitosamente",
    "failed_to_upload": "No se ha podido cargar",
    "out_warehouse": "Se despachan del almacén",
    "Sure_out_warehouse?": "¿Se afirman despachar?",
    "Dispatching": "Despachándose",
    "Successfully_dispatched_from_storage": "Se despacharon del almancén exitosamente",
    "Dispatched_from_the_warehouse_unsuccessfully": "Se despacharon del almancén fallidamente",
    "Reject_the_ticket": "Rechazar el ticket",
    "If_final_processing_is_complete,_select_the_processor_to_make_the_response_(required)": "Si se completa el procesamiento final, seleccione el encargado prara hacer la repuesta (obligatorio)",
    "Interior": "Interior",
    "Outside": "Exterior",
    "Cargo_information": "Información sobre mercancías",
    "Export_Cargo_information": "Información sobre carga de exportación",
    "inventory_anomaly": "Anomalanomalen el inventario",
    "reprint": "reimpresión",
    "twice": "Dos veces",
    "Batch_update_title": "Actualizar título por lotes",
    "No_file": "Sin archivos por el momento",
    "batch_delete": "Eliminar en lotes",
    "You_have_selected": "Has seleccionado",
    "pieces_of_document_information_Are_you_sure_you_want_to_delete_them": "información de documentos, ¿seguro que quieres eliminarlos?",
    "In_operation": "En operación",
    "Batch_deletion_succeeded": "Eliminación en lotes exitosa",
    "Batch_deletion_failed": "Error al eliminar en lotes",
    "add": "Añadiendo",
    "sku_code": "Código SKU",
    "customer_name": "Nombre del cliente",
    "time": "Tiempo",
    "driving": "Operación",
    "view": "Ver",
    "SKU_quantity_*_Unit_price": "Cantidad de SKU * Precio unitario",
    "fail_to_get": "Error al obtener",
    "Picking_situation": "Situación de selección de mercancía",
    "date": "Fecha",
    "abnormal_condition": "Condición anormal",
    "total_number_of_packages": "Número total de paquetes",
    "Pick_volume_in_the_last_seven_days": "Volumen de selección de mercancía en los últimos siete días",
    "line_chart": "Gráfico de líneas",
    "histogram": "Histograma",
    "Number_of_pending_orders": "Número de órdenes pendientes de selección",
    "Order_quantity_in_picking": "Cantidad de órdenes en selección",
    "Quantity_shipped_out_today": "Cantidad despachada hoy",
    "Refuse_to_return_to_warehouse": "Rechazar devolución al almacén",
    "Number_of_unpacked_shelves": "Número de estantes desembalados",
    "Quantity_of_original_package_transfer": "Cantidad de transferencias de paquetes originales",
    "Pick_list_number": "Número de lista de selección",
    "type": "Tipo",
    "generated_time": "Tiempo de generación",
    "creation_time": "Tiempo de creación",
    "order_quantity": "Cantidad de órdenes",
    "Total_number_of_SKUs": "Número total de SKU",
    "filter": "Filtrar",
    "reset": "Restablecer",
    "Print_the_pick_list": "Imprimir la lista de selección",
    "Are_you_sure_you_want_to_generate_a_pick_list": "¿Seguro que quieres generar una lista de selección",
    "Select": "Seleccionar",
    "print_setup": "Configuración de impresión",
    "Print_without_preview": "Imprimir sin vista previa",
    "Printer_name": "Nombre de la impresora",
    "Size_input_method": "Método de entrada de tamaño",
    "Paper_size_W_H_mm": "Tamaño del papel (ancho x alto) /mm",
    "Print_test": "Prueba de impresión",
    "Open": "Abrir",
    "Close": "Cerrar",
    "Default": "Predeterminado",
    "Custom": "Personalizado",
    "Connect_to_the_client_first": "¡Conecte primero al cliente!",
    "Please_select_a_printer": "Seleccione una impresora",
    "New_cargo_specification": "Especificación de carga nueva",
    "order_information": "Información del pedido",
    "batch_number": "Número de lote",
    "state": "Estado",
    "number_of_pieces": "Cantidad de piezas",
    "audit_status": "Estado de auditoría",
    "Outer_box_label_change_status": "Estado de cambio de etiqueta de caja exterior",
    "Number_of_containers_to_be_replaced": "Cantidad de cajas exteriores cuyas etiquetas deben ser cambiadas",
    "The_number_of_changed_packets": "Cantidad de paquetes con etiquetas cambiadas",
    "Number_of_replacement_products": "Cantidad de productos con etiquetas cambiadas",
    "Total_number_of_products_that_need_to_be_replaced": "Total de productos cuyas etiquetas deben ser cambiadas",
    "Subsingle_column_table": "Tabla de lista de subpedidos",
    "delivery_number": "Número de entrega",
    "shipping": "Número de envío",
    "Number_of_products_tag": "Número de envío/Marca de carga",
    "son_order_number": "Número de subpedido",
    "export": "Exportar",
    "change_label_status": "Estado de cambio de etiqueta",
    "Change_mark_cut_off_state": "Estado de corte de cambio de etiqueta",
    "Set_the_mark_change_cutoff_state": "Configurar el estado de corte de cambio de etiqueta",
    "goods_info": "Información de la carga",
    "Added_the_specification_information_of_cargo_change": "Información de especificación de cambio de carga añadida",
    "download_attachment": "Descargar adjunto",
    "edit": "Editar",
    "Check_SKU": "Ver SKU",
    "delete": "Eliminar",
    "export_label_pdf": "Exportar etiquetas PDF",
    "Are_you_sure_you_want_to_delete": "¿Seguro que desea eliminar?",
    "I_ll_think_about_it_again": "Voy a pensarlo de nuevo",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "Not_yet_closed": "Aún no cerrado",
    "expired": "Expirado",
    "No_change_of_mark": "Sin cambio de etiqueta",
    "Changed_mark": "Etiqueta cambiada",
    "To_be_changed": "Por cambiar",
    "changeLabeling": "Cambio de etiqueta en curso",
    "save": "Guardar",
    "saving": "Guardando",
    "Save_successfully": "Guardado correctamente",
    "Save_unsuccessfully": "Guardado fallido",
    "failed_to_get": "Obtención fallida",
    "Please_check_first": "Por favor, seleccione primero",
    "exporting": "Exportando",
    "Export_successfully": "Exportación correcta",
    "Export_unsuccessfully": "Exportación fallida",
    "Failed_to_get_details": "Obtención de detalles fallida",
    "Failed_to_obtain_the_goods_information_Procedure": "Obtención de información de carga fallida",
    "no_data_available": "Sin datos disponibles",
    "Failed_to_export_the_sheet": "Exportación de hoja fallida",
    "printing": "Imprimiendo",
    "Print_successfully": "Impresión correcta",
    "Failed_to_print": "Impresión fallida",
    "deleting": "Eliminando",
    "Successfully_deleted": "Eliminación correcta",
    "Deletion_failure": "Eliminación fallida",
    "Download_unsuccessfully": "Descarga fallida",
    "Number_of_items_that_should_have_outer_box_labels_changed": "Cantidad de artículos cuyas etiquetas de caja exterior deben ser cambiadas",
    "should_sku_num": "Cantidad de SKU cuyas etiquetas deben ser cambiadas",
    "Are_you_sure_you_want_to_delete_it": "¿Seguro que desea eliminarlo?",
    "New_shipment": "Envío nuevo",
    "Added_shipment_specification_information": "Información de especificación de envío añadida",
    "Mark_change_requirement": "Requisito de cambio de etiqueta",
    "The_outer_box_label_is_replaced_one_by_one": "Etiqueta de caja exterior cambiada obligatoriamente uno por uno",
    "Platform_type": "Tipo de plataforma",
    "Change_the_new_shipment_number": "Cambiar número de envío nuevo",
    "Change_the_shipment_number": "Cambiar número de envío",
    "If_you_only_change_the_product_label_do_not_fill_in": "Si solo cambia la etiqueta del producto, puede dejarlo en blanco",
    "query": "Consulta",
    "Please_re_check": 'Si modifica el "Tipo de requisito de cambio de etiqueta" y el "Tipo de plataforma", por favor, vuelva a consultar',
    "hide": "Ocultar",
    "expand": "Expandir",
    "original_product_label": "Etiqueta original del producto",
    "new_product_label": "Etiqueta nueva del producto",
    "number": "Cantidad",
    "add_product": "Añadir etiqueta de producto",
    "remark": "Observación",
    "Label_file_upload": "Subir archivo de etiqueta de cambio",
    "Delete_shipment_specifications": "Eliminar especificaciones de envío",
    "submit": "Enviar",
    "Failed_to_obtain_the_platform_type_Procedure": "Obtención del tipo de plataforma fallida",
    "Replace_the_outer_box_label": "Cambiar etiqueta de caja exterior",
    "Change_product_label": "Cambiar etiqueta de producto",
    "Replace_the_outer_box_label_and_product_label": "Cambiar etiqueta de caja exterior y etiqueta de producto",
    "Query_failure": "Consulta fallida",
    "Please_select_the_platform_type!": "¡Por favor, seleccione el tipo de plataforma!",
    "Please_select_an_address_type": "Por favor, seleccione el tipo de dirección",
    "Please_add_shipment": "Por favor, añadir envío",
    "Please_fill_in_the_number_of_product_labels_correctly": "Por favor, rellene correctamente el número de etiquetas de producto",
    "Please_fill_in_the_new_product_label": "Por favor, rellene la etiqueta nueva del producto",
    "Please_fill_in_the_original_product_label": "Por favor, rellene la etiqueta original del producto",
    "The_new_and_old_package_numbers_are_not_equal": "Los números de envío nuevos y viejos no son iguales",
    "Please_check_the_new_shipment_number": "Por favor, verifique el número de envío nuevo",
    "Please_enter_the_new_shipment_number": "Por favor, introduzca el número de envío nuevo",
    "Quantity_mismatch": "Desajuste de cantidad",
    "Duplicate_subshipment_numbers_exist_Procedure": "Existen números de subenvío duplicados",
    "Please_enter_data": "Por favor, introduzca datos",
    "Being_submitted": "Enviando",
    "Submit_successfully": "Enviado correctamente",
    "Commit_failure": "Envío fallido",
    "Edit_cargo_information": "Editar información de carga",
    "Change_mark_or_not": "¿Cambiar etiqueta?",
    "Total_number_of_label_changes": "Total de cambios de etiquetas",
    "Edit_SKU": "Editar SKU",
    "replace_SKU_or_not": "¿Reemplazar SKU?",
    "Change_total_quantity": "Cantidad total cambiada",
    "Old_SKU": "SKU antiguo",
    "New_SKU": "SKU nuevo",
    "Update_total_quantity": "Cantidad total actualizada",
    "allNum": "Cantidad total",
    "Confirm": "Confirmar",
    "Add": "Añadir",
    "Old_SKU_repeat": "SKU antiguo repetido",
    "Set_the_storage_start_time": "Configurar la hora de inicio del almacenamiento",
    "Set_storage_end_time": "Configurar la hora de finalización del almacenamiento",
    "Failed_to_get_list": "Fallo al obtener la lista",
    "outwarehouse_time": "Hora de salida del almacén",
    "storage_time": "Tiempo de almacenamiento",
    "number_of_squares": "Número de cuadrados",
    "Warehousing_start_time": "Hora de inicio del almacenamiento",
    "storage_time": "Duración del almacenamiento",
    "weight": "Peso",
    "End_of_storage_time": "Hora de finalización del almacenamiento",
    "Billing_phase": "Fase de facturación",
    "Restocking_stage": "Fase de reabastecimiento",
    "Warehousing_reason": "Razón del almacenamiento",
    "Calculate_storage_charges": "Calcular las tasas de almacenamiento",
    "Charging_remarks": "Observaciones de facturación",
    "Warehouse_remarks": "Observaciones del almacén",
    "charging": "Facturación",
    "no_charging": "Sin facturación",
    "start_time": "Hora de inicio",
    "end_time": "Hora de finalización",
    "Updated_in_Mexico_local_time": "Actualizado según la hora local de México",


    "order_number": "Número de orden",
    "Picking_condition": "Estado de selección",
    "creation_time": "Tiempo de creación",
    "Added_pick_list": "Nueva lista de selección",
    "Print_the_express_receipt": "Imprimir etiqueta de envío exprés",
    "Add_ing": "En proceso de añadir",
    "Add_success": "Añadido con éxito",
    "Add_failure": "Fallo en añadir",
    "Please_scan_the_SKU_code": "Por favor, escanee el código SKU",
    "print": "imprimir",
    "batch_delivery": "Entrega en lotes",
    "outwarehouse": "Salida de almacén",
    "Are_you_sure_to_leave_the_warehouse": "¿Está seguro de que desea realizar la salida del almacén?",
    "operation_succeeded": "Operación realizada con éxito",
    "operation_failure": "Fallo en la operación",
    "order_list": "Lista de órdenes",
    "sku_pick_list": "Lista de selección SKU",
    "Scan_or_enter_the_container_code": "Por favor, escanee o ingrese el código del contenedor",
    "serial_number": "Número de serie",
    "container_info": "Información del contenedor",
    "scan_out": "Escaneado para salida",
    "sku_code": "Código SKU",
    "sku_total": "Total de SKU",
    "numeration": "Numeración",
    "sku_total_quantity": "Cantidad total de SKU",
    "Unprinted_quantity": "Cantidad sin imprimir",
    "picking_bill": "Factura de selección",
    "Failed_to_obtain_the_label_library_location_Procedure": "Fallo en obtener la información de ubicación de la etiqueta",
    "Length": "Longitud",
    "Width": "Anchura",
    "Height": "Altura",
    "Weight": "Peso",
    "Basic_information": "Información básica",
    "Pick_list_number": "Número de lista de selección",
    "Platform_order_number": "Número de orden de la plataforma",
    "Express_tracking_number": "Número de seguimiento del envío exprés",
    "Platform": "Plataforma",
    "tespackaging_informationt": "Información de embalaje",
    "Shipping_information": "Información de envío",
    "contact_person": "Persona de contacto",
    "phone_contact": "Teléfono de contacto",
    "address": "Dirección",
    "telephone": "Teléfono",
    "city": "Ciudad",
    "sku_info": "Información de SKU",
    "product_name": "Nombre del producto",
    "Scan_or_enter_the_SKU_code": "Por favor, escanee o ingrese el código SKU",
    "Exit_scan": "Salir de la escaneación",
    "Scan_and_print_the_order": "Escanear y imprimir el pedido",
    "If_the_popup_window_closes_before_the_goods_have_been_scanned_rescan_is_required": "Si la ventana emergente se cerra antes de que los productos hayan sido escaneados, se necesita volver a escanear",
    "quantity_swept": "Cantidad escaneada",
    "quantity_unswept": "Cantidad no escaneada",
    "Please_enter_the_SKU_code": "Por favor, ingrese el código SKU",
    "Library_location_number": "Número de ubicación de la biblioteca",
    "Shelf_time": "Tiempo de colocación en estantería",
    "location": "Ubicación",
    "operator": "Operador",
    "Operating_time": "Tiempo de operación",
    "goods_stock": "Stock de mercancías",
    "secondary_shipment_number": "Número de envío secundario",
    "Sub_shipment_number": "Número de envío secundario",
    "sku_inventory": "Inventario de SKU",
    "quantity_of_goods": "Cantidad de mercancías",
    "sku_quantity": "Cantidad de SKU",
    "sku_code_quantity": "Cantidad de códigos SKU",
    "Failed_to_obtain_the_container_list_Procedure": "Fallo en obtener la lista de contenedores",
    "Failed_to_export_the_container_list_Procedure": "Fallo en exportar la lista de contenedores",
    "Warehousing_time": "Tiempo de almacenamiento",
    "Adjustment_order_number": "Número de orden de ajuste",
    "goods_price": "Precio de las mercancías",
    "new_construction": "Nueva construcción",
    "Please_enter": "Por favor, ingrese",
    "unit_price": "Precio unitario",
    "summation": "Total",
    "Order_number_SKU_code": "Número de orden / Código SKU",
    "name": "Nombre",
    "Library_location_log": "Registro de ubicación de la biblioteca",
    "Failed_to_obtain_log": "Fallo en obtener el registro",
    "edit_warehouse_information": "Editar información del almacén",
    "warehouse_name": "Nombre del almacén",
    "maximum_capacity": "Capacidad máxima",
    "detailed_address": "Dirección detallada",
    "editing": "En proceso de edición",
    "Edit_successfully": "Editado con éxito",
    "Edit_failure": "Fallo en la edición",
    "driving_type": "Tipo de operación",
    "order_time": "Tiempo de pedido",
    "price": "Precio",
    "shelf_a_product_to_stock": "Colocación de producto en stock",
    "sku_picking_up_goods": "SKU en proceso de selección",
    "delivery_record": "Registro de salida de almacén",
    "bar_code_printer": "Impresora de códigos de barras",
    "Whether_the_goods_have_been_picked": "¿Se han seleccionado las mercancías?",
    "weighting": "Pesaje",
    "measure_the_volume": "Medida del volumen",
    "odd": "Número impar",
    "yes": "Sí",
    "no": "No",
    "expense_rule": "Regla de gastos",
    "country": "País",
    "coefficient": "Coeficiente",
    "currency": "Moneda",
    "Maximum_unilateral_length": "Longitud máxima unilateral",
    "Update": "Actualizar",
    "The_first_weight": "Peso inicial",
    "minimum_weight": "Peso mínimo",
    "maximum_weight": "Peso máximo",
    "Stepping": "Paso",
    "Stepping_price": "Precio por paso",
    "Added_to_download_list": "Agregado a la lista de descargas",
    "Enterprise_management_background": "Fondo de gestión empresarial",
    "log": "registro",
    "Current_storage_location": "Ubicación actual del almacén",
    "Old_storage_location": "Ubicación anterior del almacén",
    "operant_hehavior": "Comportamiento operativo",
    "Storage_location_status": "Estado de la ubicación del almacén",
    "Operating_remarks": "Notas operativas",
    "Query_source": "Fuente de la consulta",
    "Old_inventory": "Inventario anterior",
    "New_inventory": "Inventario nuevo",
    "Failed_to_obtain_partition_query_data_Procedure": "Fallo en la obtención de datos de consulta de particiones",
    "Connect_to_the_client_first_and_then_print": "Conéctese primero al cliente y luego imprime",
    "upload": "subida",
    "download": "descarga",
    "source": "fuente",
    "cargo_entry_time": "Tiempo de entrada de carga",
    "Export_the_goods_data_of_the_warehouse_receipt": "Exportar datos de mercancías del recibo de almacén",
    "Transport_type": "Tipo de transporte",
    "export_list": "Lista de exportación",
    "Be_put_in_storage": "En almacén",
    "All": "Todo",
    "Confirm_the_modification": "¿Confirmar la modificación?",
    "warehousing": "Almacén",
    "shelving": "Colocación en estantería",
    "inventory_checking": "Inventario",
    "current_state": "Estado actual",
    "Available_today_piece": "Piezas/artículos disponibles hoy",
    "Todays_inventory_piece": "Piezas/artículos inventariados hoy",
    "Failed_to_obtain_warehouse_data_time_analysis_data_Procedure": "Fallo en la obtención de datos de análisis de tiempo de almacén",
    "Failed_to_obtain_warehouse_partition_data": "Fallo en la obtención de datos de particiones de almacén",
    "Failed_to_obtain_the_card_list_Procedure": "Fallo en la obtención de la lista de tarjetas",
    "Failed_to_obtain_warehouse_partition_details_Procedure": "Fallo en la obtención de detalles de particiones de almacén",
    "Commercial_Bill_of_Lading": "Conocimiento de embarque comercial",
    "Waybill_quantity": "Cantidad del conocimiento de embarque",
    "cargo_departure_time": "Tiempo de salida de carga",
    "Outbound_status": "Estado de salida",
    "customer_remarks": "Notas del cliente",
    "Customer_service_remarks": "Notas del servicio de atención al cliente",
    "Warehouse_Remarks": "Notas del almacén",
    "attachment": "Adjunto",
    "Batch_confirmation_out_warehouse": "Confirmación por lotes de salida del almacén",
    "Batch_cancel_out_warehouse": "Cancelación por lotes de salida del almacén",
    "edit_remarks": "Editar notas",
    "TC_order_number": "Número de pedido TC",
    "shipping_mark": "Marca de envío",
    "sku_name": "Nombre de SKU",
    "waiting_for_out_warehouse": "Pendiente de salida del almacén",
    "Out_of_storage": "Fuera de almacén",
    "Are_you_sure_to_batch_confirm_the_shipment": "¿Seguro que desea confirmar el envío por lotes?",
    "Are_you_sure_you_want_to_cancel_the_shipment_in_bulk": "¿Seguro que desea cancelar el envío por lotes?",
    "Attachment_upload_status": "Estado de subida de adjuntos",
    "Pickup_or_not": "Recogida propia o no",
    "The_waybill_has_been_handed_over_to_the_consignee_before_delivery": "Antes de realizar la salida del almacén, por favor, confirme que todos los conocimientos de embarque de la lote de selección actual han sido entregados al destinatario",
    "Batch_order_number": "Número de pedido por lotes",
    "haven_t_uploaded": "No subido",
    "have_already_uploaded": "Ya subido",
    "pick_up_in_a_store": "Recogida propia",
    "Distribution_collection_point": "Punto de recogida y distribución",
    "One_out_of_the_warehouse": "Salida de almacén por pedido único",
    "Failed_to_obtain_the_customer_name_list": "Fallo en la obtención de la lista de nombres de clientes",
    "Added_to_download_list": "Agregado a la lista de descargas",
    "Please_select_an_address_template": "Por favor, seleccione una plantilla de dirección",
    "export_data": "Exportación de datos",
    "total_pieces_piece": "Total de piezas/artículos",
    "total_volume_cubic_meters": "Volumen total/metros cúbicos",
    "total_weight_kg": "Peso total/kilogramos",
    "Update_failure": "Fallo en la actualización",
    "Shipment_no_number": "Número de envío",
    "Failed_to_obtain_the_warehouse_partition_list_Procedure": "Fallo en la obtención de la lista de particiones de almacén",
    "Failed_to_obtain_warehouse_details": "Fallo en la obtención de detalles del almacén",
    "Add_Layer": "Agregar capa",
    "Number_of_layers": "Número de capas",
    "Add_location": "Agregar ubicación",
    "location_count": "Número de ubicaciones",
    "Failed_to_get_the_vehicle_list": "Fallo en la obtención de la lista de vehículos",
    "Add_warehouse_Information": "Agregar información de almacén",
    "Edit_warehouse_Information": "Editar información de almacén",
    "pending": "Pendiente de revisión",
    "audited": "Revisado",
    "Failed_to_get_the_order_list": "Fallo en la obtención de la lista de pedidos",
    "Failed_to_obtain_shipment_warehouse": "Fallo en la obtención del almacén de envío",
    "Failed_to_obtain_the_shipping_type_Procedure": "Fallo en la obtención del tipo de envío",
    "Edit_the_shipment_number": "Editar el número de envío",
    "Merge_suborder": "Fusionar subpedidos",
    "Please_enter_the_TC_suborder": "Por favor, ingrese el subpedido TC",
    "detection": "Detección",
    "Subshipment_number_data": "Datos del número de subenvío",
    "suborder_data": "Datos del subpedido",
    "scanning_time": "Tiempo de escaneado",
    "Takedown_time": "Tiempo de baja",
    "Return_time": "Tiempo de retorno",
    "Data_confirmed_after_merging": "Confirmación de datos después de la fusion",
    "Definite_merge": "Fusionar definitivamente",
    "Merger_ing": "Fusionando",
    "Merger_successful": "Fusionación exitosa",
    "Merge_failure": "Fusionación fallida",
    "detection_failure": "Fallo en la detección",
    "The_suborder_determines_the_status": "El subpedido determina el estado",
    "uncertain": "Indeterminado",
    "confirmed": "Confirmado",
    "storage_age": "Antigüedad en almacén",
    "Check_the_stream": "Ver el flujo",
    "Settlement_of_storage_charges": "Liquidación de gastos de almacenaje",
    "Termination_of_charge": "Terminación de cargo",
    "tc_subtracking_number": "Número de subseguimiento TC",
    "Cargo_flow": "Flujo de carga",
    "movement": "Movimiento",
    "operator2": "Operario",
    "secondary_shipping/secondary_outer_carton_label": "Número de subenvío/etiqueta secundaria del cartón exterior",
    "Warehouse_area": "Área del almacén",
    "other_description": "Otra descripción",
    "Whether_to_request_destruction": "Solicitar destrucción o no",
    "scan_time": "Tiempo de escaneado",
    "Are_you_sure_to_destroy_the_goods": "¿Está seguro de que desea destruir los productos?",
    "Failed_to_get_the_inventory_status_list": "Falló la obtención de la lista de estados de inventario",
    "Failed_to_obtain_the_database_location_list_Procedure": "Falló el procedimiento de obtención de la lista de ubicaciones de base de datos",
    "Update_the_outbound_time": "Actualizar el tiempo de salida",
    "The_number_of_squares_is_zero": "El número de cuadrados es cero",
    "Weight_zero": "Peso cero",
    "Export_the_customer_box_label": "Exportar la etiqueta de caja del cliente",
    "Estimated_time_of_arrival": "Tiempo estimado de llegada",
    "Failed_to_obtain_the_SKU_list_Procedure": "Falló el procedimiento de obtención de la lista de SKU",
    "Failed_to_obtain_system_details": "Falló la obtención de detalles del sistema",
    "Are_they_all_out_of_storage_If_the_product_is_missing_please_enter_the_details_to_specify_the_outlet": "¿Están todos fuera del almacén? Si falta algún producto, por favor ingrese los detalles para especificar el punto de salida",
    "All_out": "Todos fuera",
    "Assigns_the_storehouse": "Especifica el punto de salida",
    "Generate_a_pick_list": "Generar una lista de selección",
    "Allocation_status": "Estado de asignación de mercancía",
    "not_generate": "no generado",
    "generated": "generado",
    "Delivery_date": "Fecha de entrega al almacén",
    "Number_of_containers_that_have_been_replaced": "Número de etiquetas de cajas externas ya cambiadas",
    "Product_label_change_status": "Estado del cambio de etiqueta del producto",
    "Number_of_replaced_product_standards": "Número de etiquetas de productos ya cambiadas",
    "Need_to_change_the_outer_box_label": "Necesita cambiar la etiqueta de la caja externa",
    "Need_to_change_the_product_label": "Necesita cambiar la etiqueta del producto",
    "Whether_the_label_has_been_changed": "Si la etiqueta ya ha sido cambiada",
    "converted_quantities": "Cantidades ya cambiadas",
    "Unchanged_quantity": "Cantidad sin cambiar",
    "Number_of_products_that_need_to_be_replaced": "Número de etiquetas de productos que necesitan ser cambiadas",
    "Change_the_SKU": "Cambiar etiqueta SKU",
    "Old_shipment_number": "Número de envío antiguo",
    "New_shipment_number": "Nuevo número de envío",
    "The_shipment_number_has_been_replaced": "El número de envío ha sido reemplazado",
    "No_replacement_package_number": "No hay número de envío de reemplazo",
    "The_subshipment_number_should_be_changed": "El número de subenvío debe ser cambiado",
    "Label_change_operation_logs": "Registros de operaciones de cambio de etiqueta",
    "Shipment_number_change": "Cambio de etiqueta del número de envío",
    "sku_change": "Cambio de etiqueta de SKU",
    "Description_Failed_to_obtain_the_label_change_operation_log": "Falló la obtención del registro de operaciones de cambio de etiqueta",
    "Reload_attachment_information_succeeded_Procedure": "Recarga de información de adjuntos exitosa",
    "Failed_to_reload_attachment_information_Procedure": "Error al recargar la información de adjuntos",
    "Reload_attachment": "Recargar adjunto",
    "Has_the_outbound_order_been_exported": "Si alguna orden de salida ha sido exportada",
    "classify": "clasificar",
    "outbound_delivery_order": "albarán de salida",
    "label": "etiqueta",
    "Batch_download_the_outbound_order_information": "Descargar por lote la información del albarán de salida",
    "Obtain_information": "Obtener información",
    "Achieve_success": "Obtener el éxito",
    "Achieve_failure": "Falla de adquisición",
    "Obtaining": "Obteniendo",
    "Information_has_been_obtained_Please_click_to_export": "La información se ha obtenido por completo, haga clic en exportar",
    "Whether_to_split": "¿Si se divide o no",
    "Split_files": "Número de piezas divididas",
    "conditional_split": "Condiciones de división",
    "taskname": "Nombre de la tarea",
    "number_of_packages": "Número de paquetes",
    "create_user_realname": "Creador",
    "create_search_goods_task_task": "Crear tarea de búsqueda de mercancías",
    "add_search_goods_task_task": "Agregar tarea de búsqueda de mercancías",
    "List_of_goods_search_information": "Lista de información de búsqueda de mercancías",
    "Batch_input_suborder_numbers": "Ingreso masivo de números de subórdenes",
    "Export_the_work_order_description": "Exportar descripción de la orden de trabajo",
    "Delivery_item_number": "Número de envío para entrega en almacén",
    "Container_number": "Número de contenedor",
    "rfid_quantity": "Cantidad de RFID",
    "Undetected_quantity": "Cantidad no detectada",
    "Has_it_been_detected": "¿Ha sido detectado?",
    "List_of_inbound_inspection_tasks": "Lista de tareas de inspección de entrada",
    "The_sublist_was_not_detected": "Sublista no detectada",
    "The_sublist_has_been_inspected": "Sublista detectada",
    "undetected": "No detectado",
    "detected": "Detectado",
    "Supplement_the_past_outbound_orders": "Suplementar los pedidos de salida anteriores",
    "The_number_of_unchanged_product_labels": "Cantidad de etiquetas de productos no cambiadas",
    "Upload_the_manual_label_change_file": "Subir archivo de cambio de etiqueta manual",
    "Label_change_type": "Tipo de cambio de etiqueta",
    "area": "Área",
    "upload_files": "Subir archivos",
    "Please_select_the_date_first": "Por favor, seleccione la fecha primero",
    "Failed_to_obtain_the_date": "Error al obtener la fecha",
    "Failed_to_obtain_the_repository": "Error al obtener el almacén",
    "store_code": "Código de almacén",
    "Export_pdf": "Exportar a pdf",
    "box_label": "Etiqueta de caja",
    "Upload_list": "Lista de carga",
    "old_sku": "SKU original",
    "new_sku": "SKU nuevo",
    "Inventory_Location_Type": "tipo de ubicación de inventario",
    "The_file_name_cannot_contain_special_characters": "El nombre del archivo no puede contener caracteres especiales",
    "Export_the_information_of_goods_leaving_the_warehouse": "Exportar información de mercancías de salida del almacén",
    "Exit_request_status": "Estado de la solicitud de salida del almacén",
    "scan_status": "Estado de escaneo",
    "warehouse_loading_status": "Estado de carga en el almacén",
    "Normal_warehouse_exit": "Salida normal del almacén",
    "The_platform_refuses_to_accept": "La plataforma rechaza aceptar",
    "Suspend_position_exit": "Suspender salida del almacén",
    "To_be_scanned": "Pendiente de escaneo",
    "Inventory_has_been_scanned_for_release": "Inventario escaneado para salida",
    "Not_scanned_code": "Código no escaneado",
    "Scanned_code": "Código escaneado",
    "Has_been_read": "¿Ha sido leído?",
    "unread": "No leído",
    "read": "Leído",
    "Set_to_read": "Marcar como leído",
    "Are_you_sure_the_Settings_are_read": "¿Estás seguro de marcar como leído?",
    "occurrence_time": "Tiempo de ocurrencia",
    "Attention": "¡Atención!",
    "Please_do_not_input_the_file_extension": "Por favor, no introduzca sufijos de archivo",
    "Screenshot_of_the_export_page": "Captura de pantalla de la página de exportación",
    "Copy_download_link": "Copiar enlace de descarga",
    "Copy_successfully": "Copia exitosa",
    "Copy_failed": "Fallo al copiar",
    "Goods_delivered_to_the_warehouse_multiple_times": "Mercancías entregadas al almacén varias veces",
    "The_date_cannot_be_empty": "La fecha no puede estar vacía",
    "Change_the_number_of_packages": "Modificar el número de artículos con cambio de etiqueta",
    "The_current_number_of_rebranded_items": "Número actual de artículos con cambio de etiqueta",
    "old_warehouse": "almacén antiguo",
    "current_warehouse": "almacén actual",
    "inbound_date": "Fecha de ingreso al almacén",
    "Quantity_in_Stock": "Cantidad ingresada",
    "warehouse_selection": "Selección de almacén",
    "Total_quantity_in_stock": "Cantidad total ingresada",
    "Warehouse_entry_registration": "Registro de entrega al almacén",
    "New_Warehouse_entry_registration": "Nuevo registro de entrega al almacén",
    "reservation_number": "Número de reserva",
    "Quantity_of_goods": "Cantidad de mercancías",
    "Please_fill_in_the_information_completely": "Por favor, complete la información",
    "Are_you_sure_you_want_to_cancel_the_reservation_registration": "¿Está seguro de que desea cancelar el registro de reserva?",
    "Cancel_reservation_registration": "Cancelar registro de reserva",
    "Update_delivery_time": "Actualizar tiempo de entrega al almacén",
    "New_import": "Nueva importación",
    "update_status": "Actualizar estado",
    "Quantity_of_label_changes": "Cantidad de cambios de etiqueta",
    "Delivery_method": "Método de entrega",
    "Update_the_delivery_method": "Actualizar el método de entrega",
    "Failed_to_obtain_the_repository_list": "Error al obtener la lista de almacenes",
    "First_listing_time": "Hora de primera publicación",
    "Is_the_suborder_empty": "¿El subpedido está vacío?",
    "empty": "Vacío",
    "non_empty": "No vacío",
    "In_the_past_month": "Último mes",
    "go_back": "Volver",
    "dashboard": "Panel de calidad",
    "overseas_listing_exception": "Excepción de listado en ultramar",
    "total_unlisted_quantity": "Total sin listar",
    "warehousing_date": "F. entrada",
    "container_count": "Nº contenedores",
    "quantity_to_be_listed": "Cant. por listar",
    "unlisted_quantity": "Cant. sin listar",
    "overseas_outbound_exception": "Excepción salida ultramar",
    "total_rejected_quantity": "Total rechazado",
    "total_intercepted_quantity": "Total interceptado",
    "total_unscanned_quantity": "Total sin escanear",
    "outbound_date": "F. salida",
    "rejected_quantity": "Cant. rechazada",
    "intercepted_quantity": "Cant. interceptada",
    "unscanned_quantity": "Cant. sin escanear",
    "box_damage_summary": "Resumen daños cajas",
    "total_damaged_quantity": "Total dañado",
    "total_repaired_quantity": "Total reparado",
    "damaged_quantity": "Cant. dañada",
    "repaired_quantity": "Cant. reparada",
    "failed_to_get_overseas_listing_exception": "Error al obtener excepción de listado en ultramar",
    "failed_to_get_overseas_outbound_exception": "Error al obtener excepción de salida en ultramar",
    "failed_to_get_box_damage_summary": "Error al obtener resumen de daños en cajas",
    "Change_the_inventory_to_unknown": "Cambiar el inventario a desconocido",
    "Are_you_sure_you_want_to_change_the_inventory_to_unknown": "¿Está seguro de que desea cambiar el inventario a desconocido?",
    "Is_there_any_rejection": "¿Hay algún rechazo?",
  },
}